export default {
  zh: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - 字节跳动旗舰级 AI 图像生成模型',
      pageDescription: 'Seedream 4.5 是字节跳动最新推出的旗舰级 AI 图像模型，专注于精准文字渲染与多图融合，支持4K超清画质输出。立即在 微鲤AI 免费体验。',
      pageKeywords: 'Seedream 4.5, AI图像生成, 文字渲染, 多图融合, 字节跳动, 4K画质, 微鲤AI',
      ogTitle: 'Seedream 4.5 AI 图像生成器 | 微鲤AI',
      ogDescription: 'Seedream 4.5 字节跳动旗舰级AI图像模型，精准文字渲染与多图融合',
      twitterTitle: 'Seedream 4.5 - 字节跳动旗舰级 AI 图像生成',
      twitterDescription: '体验 Seedream 4.5 的强大图像生成能力，精准文字渲染，4K超清画质',

      // Generator Section
      generatorTitle: 'Seedream 4.5 图像生成器',
      generatorSubtitle: 'Seedream 4.5 图像生成器是字节跳动（ByteDance）旗下最新推出的旗舰级 AI 图像模型。作为Seedream 系列的重大升级版，它突破了传统文生图模型的限制，专注于解决专业创作中最棘手的"一致性"与"文本渲染"难题。该模型以其惊人的多图融合能力、精确的排版文字生成以及对光影细节的电影级把控而著称，是设计师、电商从业者及品牌创作者的理想工具。快来 微鲤AI 免费体验 Seedream 4.5 的极致专业创作能力吧！',

      // Core Features
      coreFeaturesTitle: 'Seedream 4.5 核心功能',
      coreFeaturesSubtitle: '探索 Seedream 4.5 的强大功能，开启专业级 AI 图像创作之旅',

      feature1Title: '精准排版与文字渲染',
      feature1Desc: 'Seedream 4.5 解决了AI生成图片中文字乱码的通病。它能精准地在图像中生成清晰、拼写正确的标题、标签和长句，非常适合制作海报、书籍封面及带有Logo的产品图。',
      feature1Alt: 'Seedream 4.5 精准排版与文字渲染示例',

      feature2Title: '多图融合与一致性控制',
      feature2Desc: '支持同时输入多达10张参考图像，模型能智能提取不同图片中的人物特征、服装细节或环境风格，并将它们完美融合到一张新图中，确保人物ID和核心元素在不同场景下保持高度一致。',
      feature2Alt: 'Seedream 4.5 多图融合示例',

      feature3Title: '智能局部重绘与编辑',
      feature3Desc: '不同于简单的遮罩重绘，Seedream 4.5 能理解画面原本的光影逻辑。当你要求"换一件衣服"或"改变背景"时，它不仅能替换物体，还能自动调整周围环境的反射光和阴影，使修改后的痕迹天衣无缝。',
      feature3Alt: 'Seedream 4.5 智能局部重绘示例',

      feature4Title: '电影级4K超清画质',
      feature4Desc: '原生支持生成4K分辨率的高细节图像，无需后期放大。其增强的物理渲染引擎能模拟真实世界的相机景深、材质纹理（如皮肤毛孔、织物纤维）和复杂的光线散射效果。',
      feature4Alt: 'Seedream 4.5 4K画质示例',

      // How to Use
      howToUseTitle: '如何在 微鲤AI 上使用 Seedream 4.5',
      howToUseSubtitle: '简单三步，开始创作',

      step1Title: '选择模型',
      step1Description: '在 AI 图像工具中选择 Seedream 4.5 模型',

      step2Title: '输入内容',
      step2Description: '输入提示词或上传参考图像',

      step3Title: '生成图像',
      step3Description: '点击生成按钮，等待并下载您的图像',

      // YouTube Section
      youtubeTitle: '关于 Seedream 4.5 AI 图像模型的 YouTube 视频',

      // X Posts Section
      xPostsTitle: '关于 Seedream 4.5 AI 图像模型的 X 帖子',

      // Explore Models
      exploreModelsTitle: '探索 微鲤AI 上的其他图像模型',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      // FAQ
      faqTitle: '常见问题解答',

      faq1Question: 'Seedream 4.5 是什么？',
      faq1Answer: 'Seedream 4.5 是字节跳动开发的一款先进AI图像生成与编辑模型，它在保持画面一致性、精准还原文字以及高分辨率输出方面处于行业领先地位。',

      faq2Question: '它主要能做什么？',
      faq2Answer: '它最擅长生成带有准确文字的海报/Logo、保持人物ID一致的连续分镜、逼真的电商产品图，以及进行复杂的局部图像编辑（如换装、换背景）。',

      faq3Question: '在 微鲤AI 上使用是免费的吗？',
      faq3Answer: '微鲤AI 为注册用户提供每日免费的积分额度，可用于体验 Seedream 4.5。如需大量生成或商用高清无水印下载，我们提供灵活的会员订阅计划。',

      faq4Question: '生成图片的质量如何？',
      faq4Answer: 'Seedream 4.5 支持原生 4K 分辨率输出，画质细腻，光影逻辑严谨，特别是在人像皮肤纹理和物体材质（如金属、玻璃）的表现上达到了商业摄影级别。',

      faq5Question: '它和 Flux.1 或 Midjourney 有什么区别？',
      faq5Answer: '相比其他模型，Seedream 4.5 最大的优势在于可控性。它对参考图的还原度更高（多图融合功能），并且在生成图片内嵌文字（Typography）方面表现更为出色，更适合商业设计用途。',

      faq6Question: '我可以将生成的图片用于商业用途吗？',
      faq6Answer: '是的，通过 微鲤AI 平台生成的 Seedream 4.5 图片，在符合平台服务条款和当地法律法规的前提下，您拥有其商业使用权。',

      // CTA Section
      ctaTitle: '立即体验 Seedream 4.5',
      ctaDescription: '免费使用字节跳动最强大的AI图像生成模型',
      ctaButton: '开始创作',
      ctaDisclaimer: '无需信用卡，立即开始',
  },
  en: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - ByteDance Flagship AI Image Generation Model',
      pageDescription: "Seedream 4.5 is ByteDance\'s latest flagship AI image model, focusing on precise typography rendering and multi-image fusion with 4K ultra-HD output. Try it free on 微鲤AI.",
      pageKeywords: 'Seedream 4.5, AI image generation, typography rendering, multi-image fusion, ByteDance, 4K quality, 微鲤AI',
      ogTitle: 'Seedream 4.5 AI Image Generator | 微鲤AI',
      ogDescription: "Seedream 4.5 ByteDance\'s flagship AI image model with precise typography and multi-image fusion",
      twitterTitle: 'Seedream 4.5 - ByteDance Flagship AI Image Generation',
      twitterDescription: 'Experience Seedream 4.5 powerful image generation, precise typography, 4K ultra-HD quality',

      // Generator Section
      generatorTitle: 'Seedream 4.5 Image Generator',
      generatorSubtitle: "Seedream 4.5 Image Generator is ByteDance\'s latest flagship AI image model. As a major upgrade to the Seedream series, it breaks through the limitations of traditional text-to-image models, focusing on solving the most challenging consistency and text rendering problems in professional creation. The model is renowned for its amazing multi-image fusion capability, precise typography generation, and cinematic control of lighting details, making it an ideal tool for designers, e-commerce professionals, and brand creators. Try Seedream 4.5's ultimate professional creative capabilities for free on 微鲤AI!",

      // Core Features
      coreFeaturesTitle: 'Seedream 4.5 Core Features',
      coreFeaturesSubtitle: 'Explore the powerful features of Seedream 4.5 and start your professional AI image creation journey',

      feature1Title: 'Precise Typography & Text Rendering',
      feature1Desc: 'Seedream 4.5 solves the common problem of garbled text in AI-generated images. It can precisely generate clear, correctly spelled titles, labels, and long sentences in images, making it ideal for creating posters, book covers, and product images with logos.',
      feature1Alt: 'Seedream 4.5 precise typography example',

      feature2Title: 'Multi-Image Fusion & Consistency Control',
      feature2Desc: 'Supports input of up to 10 reference images simultaneously. The model can intelligently extract character features, clothing details, or environmental styles from different images and perfectly blend them into a new image, ensuring character ID and core elements remain highly consistent across different scenes.',
      feature2Alt: 'Seedream 4.5 multi-image fusion example',

      feature3Title: 'Intelligent Inpainting & Editing',
      feature3Desc: 'Unlike simple mask inpainting, Seedream 4.5 understands the original lighting logic of the scene. When you request to "change clothes" or "change background", it not only replaces the object but also automatically adjusts the reflected light and shadows in the surrounding environment, making the modification seamless.',
      feature3Alt: 'Seedream 4.5 intelligent inpainting example',

      feature4Title: 'Cinematic 4K Ultra HD Quality',
      feature4Desc: 'Natively supports generating 4K resolution high-detail images without post-processing upscaling. Its enhanced physics rendering engine can simulate real-world camera depth of field, material textures (like skin pores, fabric fibers), and complex light scattering effects.',
      feature4Alt: 'Seedream 4.5 4K quality example',

      // How to Use
      howToUseTitle: 'How to Use Seedream 4.5 on 微鲤AI',
      howToUseSubtitle: 'Get started in just three steps',

      step1Title: 'Select Model',
      step1Description: 'Choose Seedream 4.5 in the AI Image tools',

      step2Title: 'Enter Content',
      step2Description: 'Enter prompts or upload reference images',

      step3Title: 'Generate Image',
      step3Description: 'Click generate and download your image',

      // YouTube Section
      youtubeTitle: 'YouTube Videos About Seedream 4.5 AI Image Model',

      // X Posts Section
      xPostsTitle: 'X Posts About Seedream 4.5 AI Image Model',

      // Explore Models
      exploreModelsTitle: 'Explore Other Image Models on 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      // FAQ
      faqTitle: 'Frequently Asked Questions',

      faq1Question: 'What is Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 is an advanced AI image generation and editing model developed by ByteDance, leading the industry in maintaining visual consistency, precise text reproduction, and high-resolution output.',

      faq2Question: 'What can it do?',
      faq2Answer: 'It excels at generating posters/logos with accurate text, continuous storyboards with consistent character IDs, realistic e-commerce product images, and complex local image editing (such as changing clothes or backgrounds).',

      faq3Question: 'Is it free to use on 微鲤AI?',
      faq3Answer: '微鲤AI provides daily free credits for registered users to experience Seedream 4.5. For bulk generation or commercial HD watermark-free downloads, we offer flexible subscription plans.',

      faq4Question: 'What is the image quality?',
      faq4Answer: 'Seedream 4.5 supports native 4K resolution output with delicate image quality and rigorous lighting logic, especially achieving commercial photography level in portrait skin texture and material representation (such as metal, glass).',

      faq5Question: 'How is it different from Flux.1 or Midjourney?',
      faq5Answer: "Compared to other models, Seedream 4.5's biggest advantage is controllability. It has higher fidelity to reference images (multi-image fusion) and performs better in generating embedded text (Typography), making it more suitable for commercial design.",

      faq6Question: 'Can I use generated images commercially?',
      faq6Answer: 'Yes, images generated through Seedream 4.5 on the 微鲤AI platform can be used commercially, subject to platform terms of service and local laws.',

      // CTA Section
      ctaTitle: 'Try Seedream 4.5 Now',
      ctaDescription: "Use ByteDance\'s most powerful AI image generation model for free",
      ctaButton: 'Start Creating',
      ctaDisclaimer: 'No credit card required',
  },
  ja: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - ByteDanceフラッグシップAI画像生成モデル',
      pageDescription: 'Seedream 4.5はByteDanceの最新フラッグシップAI画像モデルで、精密な文字レンダリングとマルチ画像融合、4K超高画質出力に対応。WeryAIで無料体験。',
      pageKeywords: 'Seedream 4.5, AI画像生成, 文字レンダリング, マルチ画像融合, ByteDance, 4K画質, 微鲤AI',

      // Generator Section
      generatorTitle: 'Seedream 4.5 画像ジェネレーター',
      generatorSubtitle: 'Seedream 4.5はByteDanceの最新フラッグシップAI画像モデルです。Seedreamシリーズの大幅なアップグレードとして、従来のテキストから画像への変換モデルの限界を突破し、プロフェッショナルな創作における最も困難な「一貫性」と「テキストレンダリング」の問題を解決することに焦点を当てています。',

      // Core Features
      coreFeaturesTitle: 'Seedream 4.5 コア機能',
      coreFeaturesSubtitle: 'Seedream 4.5の強力な機能を探索',

      feature1Title: '精密なタイポグラフィとテキストレンダリング',
      feature1Desc: 'Seedream 4.5は、AI生成画像における文字化けの一般的な問題を解決します。画像内に明確で正しいスペルのタイトル、ラベル、長文を正確に生成でき、ポスター、書籍の表紙、ロゴ入り製品画像の作成に最適です。',

      feature2Title: 'マルチ画像融合と一貫性制御',
      feature2Desc: '最大10枚の参照画像の同時入力をサポート。モデルは異なる画像からキャラクターの特徴、服装の詳細、環境スタイルをインテリジェントに抽出し、新しい画像に完璧に融合させます。',

      feature3Title: 'インテリジェントなインペインティングと編集',
      feature3Desc: '単純なマスクインペインティングとは異なり、Seedream 4.5はシーンの元の照明ロジックを理解します。',

      feature4Title: 'シネマティック4K超高画質',
      feature4Desc: '後処理なしで4K解像度の高詳細画像のネイティブ生成をサポート。',

      // How to Use
      howToUseTitle: 'WeryAIでSeedream 4.5を使用する方法',
      step1Title: 'モデルを選択',
      step1Description: 'AI画像ツールでSeedream 4.5を選択',
      step2Title: 'コンテンツを入力',
      step2Description: 'プロンプトを入力するか参照画像をアップロード',
      step3Title: '画像を生成',
      step3Description: '生成をクリックして画像をダウンロード',

      youtubeTitle: 'Seedream 4.5 AI画像モデルに関するYouTube動画',
      xPostsTitle: 'Seedream 4.5 AI画像モデルに関するXの投稿',
      exploreModelsTitle: 'WeryAIの他の画像モデルを探索',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',
      faqTitle: 'よくある質問',

      faq1Question: 'Seedream 4.5とは？',
      faq1Answer: 'Seedream 4.5はByteDanceが開発した先進的なAI画像生成・編集モデルで、視覚的一貫性の維持、正確なテキスト再現、高解像度出力において業界をリードしています。',

      faq2Question: '何ができますか？',
      faq2Answer: '正確なテキスト付きのポスター/ロゴの生成、一貫したキャラクターIDの連続ストーリーボード、リアルなEC商品画像、複雑なローカル画像編集に優れています。',

      faq3Question: 'WeryAIで無料で使えますか？',
      faq3Answer: 'WeryAIは登録ユーザーに毎日無料のクレジットを提供しています。',

      faq4Question: '画像品質はどうですか？',
      faq4Answer: 'Seedream 4.5はネイティブ4K解像度出力をサポートし、きめ細かい画質と厳格な照明ロジックを提供します。',

      faq5Question: 'Flux.1やMidjourneyとの違いは？',
      faq5Answer: '他のモデルと比較して、Seedream 4.5の最大の利点は制御性です。',

      faq6Question: '商用利用できますか？',
      faq6Answer: 'はい、WeryAIプラットフォームで生成されたSeedream 4.5画像は、プラットフォームの利用規約と現地の法律に従って商用利用できます。',

      ctaTitle: '今すぐSeedream 4.5を試す',
      ctaDescription: 'ByteDanceの最も強力なAI画像生成モデルを無料で使用',
      ctaButton: '創作を開始',
      ctaDisclaimer: 'クレジットカード不要',
  },
  ko: {
      pageTitle: 'Seedream 4.5 - ByteDance 플래그십 AI 이미지 생성 모델',
      generatorTitle: 'Seedream 4.5 이미지 생성기',
      generatorSubtitle: 'Seedream 4.5는 ByteDance의 최신 플래그십 AI 이미지 모델입니다. Seedream 시리즈의 주요 업그레이드로서, 전통적인 텍스트-이미지 모델의 한계를 돌파하여 전문 창작에서 가장 어려운 "일관성"과 "텍스트 렌더링" 문제를 해결하는 데 중점을 둡니다.',
      coreFeaturesTitle: 'Seedream 4.5 핵심 기능',
      feature1Title: '정밀한 타이포그래피 및 텍스트 렌더링',
      feature1Desc: 'Seedream 4.5는 AI 생성 이미지에서 문자 깨짐의 일반적인 문제를 해결합니다.',
      feature2Title: '다중 이미지 융합 및 일관성 제어',
      feature2Desc: '최대 10개의 참조 이미지 동시 입력을 지원합니다.',
      feature3Title: '지능형 인페인팅 및 편집',
      feature3Desc: '단순한 마스크 인페인팅과 달리, Seedream 4.5는 장면의 원래 조명 로직을 이해합니다.',
      feature4Title: '시네마틱 4K 초고화질',
      feature4Desc: '후처리 없이 4K 해상도 고화질 이미지의 네이티브 생성을 지원합니다.',
      howToUseTitle: 'WeryAI에서 Seedream 4.5 사용 방법',
      step1Title: '모델 선택',
      step1Description: 'AI 이미지 도구에서 Seedream 4.5 선택',
      step2Title: '콘텐츠 입력',
      step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
      step3Title: '이미지 생성',
      step3Description: '생성을 클릭하고 이미지 다운로드',
      youtubeTitle: 'Seedream 4.5 AI 이미지 모델 관련 YouTube 동영상',
      xPostsTitle: 'Seedream 4.5 AI 이미지 모델 관련 X 게시물',
      exploreModelsTitle: 'WeryAI의 다른 이미지 모델 탐색',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',
      faqTitle: '자주 묻는 질문',
      faq1Question: 'Seedream 4.5란?',
      faq1Answer: 'Seedream 4.5는 ByteDance가 개발한 고급 AI 이미지 생성 및 편집 모델입니다.',
      faq2Question: '무엇을 할 수 있나요?',
      faq2Answer: '정확한 텍스트가 포함된 포스터/로고 생성, 일관된 캐릭터 ID의 연속 스토리보드 등에 탁월합니다.',
      faq3Question: 'WeryAI에서 무료로 사용할 수 있나요?',
      faq3Answer: 'WeryAI는 등록 사용자에게 매일 무료 크레딧을 제공합니다.',
      faq4Question: '이미지 품질은 어떤가요?',
      faq4Answer: 'Seedream 4.5는 네이티브 4K 해상도 출력을 지원합니다.',
      faq5Question: 'Flux.1이나 Midjourney와 어떻게 다른가요?',
      faq5Answer: '다른 모델과 비교했을 때, Seedream 4.5의 가장 큰 장점은 제어 가능성입니다.',
      faq6Question: '상업적으로 사용할 수 있나요?',
      faq6Answer: '네, 微鲤AI 플랫폼에서 생성된 Seedream 4.5 이미지는 상업적으로 사용할 수 있습니다.',
      ctaTitle: '지금 Seedream 4.5 체험하기',
      ctaDescription: 'ByteDance의 가장 강력한 AI 이미지 생성 모델을 무료로 사용',
      ctaButton: '창작 시작',
      ctaDisclaimer: '신용카드 불필요',
  },
  es: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - Modelo de Generación de Imágenes IA de ByteDance',
      pageDescription: 'Seedream 4.5 es el último modelo de imagen IA insignia de ByteDance, enfocado en renderizado preciso de tipografía y fusión de múltiples imágenes con salida 4K ultra HD. Pruébalo gratis en 微鲤AI.',
      pageKeywords: 'Seedream 4.5, generación de imágenes IA, renderizado tipográfico, fusión de imágenes, ByteDance, calidad 4K, 微鲤AI',

      // Generator Section
      generatorTitle: 'Generador de Imágenes Seedream 4.5',
      generatorSubtitle: 'Seedream 4.5 es el último modelo de imagen IA insignia de ByteDance. Como una actualización importante de la serie Seedream, rompe las limitaciones de los modelos tradicionales de texto a imagen, centrándose en resolver los problemas más desafiantes de consistencia y renderizado de texto en la creación profesional.',

      // Core Features
      coreFeaturesTitle: 'Características Principales de Seedream 4.5',
      coreFeaturesSubtitle: 'Explora las poderosas funciones de Seedream 4.5',

      feature1Title: 'Tipografía Precisa y Renderizado de Texto',
      feature1Desc: 'Seedream 4.5 resuelve el problema común de texto ilegible en imágenes generadas por IA. Puede generar con precisión títulos, etiquetas y oraciones largas claras y correctamente escritas, ideal para crear pósters, portadas de libros e imágenes de productos con logos.',

      feature2Title: 'Fusión Multi-Imagen y Control de Consistencia',
      feature2Desc: 'Soporta entrada simultánea de hasta 10 imágenes de referencia. El modelo puede extraer inteligentemente características de personajes, detalles de ropa o estilos ambientales de diferentes imágenes y fusionarlos perfectamente.',

      feature3Title: 'Inpainting Inteligente y Edición',
      feature3Desc: 'A diferencia del simple inpainting con máscara, Seedream 4.5 comprende la lógica de iluminación original de la escena.',

      feature4Title: 'Calidad Cinematográfica 4K Ultra HD',
      feature4Desc: 'Soporta generación nativa de imágenes de alta definición 4K sin necesidad de escalado posterior.',

      // How to Use
      howToUseTitle: 'Cómo Usar Seedream 4.5 en 微鲤AI',
      step1Title: 'Seleccionar Modelo',
      step1Description: 'Elige Seedream 4.5 en las herramientas de imagen IA',
      step2Title: 'Ingresar Contenido',
      step2Description: 'Ingresa prompts o sube imágenes de referencia',
      step3Title: 'Generar Imagen',
      step3Description: 'Haz clic en generar y descarga tu imagen',

      youtubeTitle: 'Videos de YouTube sobre el Modelo de Imagen IA Seedream 4.5',
      xPostsTitle: 'Publicaciones de X sobre el Modelo de Imagen IA Seedream 4.5',
      exploreModelsTitle: 'Explora Otros Modelos de Imagen en 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      faqTitle: 'Preguntas Frecuentes',
      faq1Question: '¿Qué es Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 es un modelo avanzado de generación y edición de imágenes IA desarrollado por ByteDance, líder en la industria en mantener consistencia visual, reproducción precisa de texto y salida de alta resolución.',
      faq2Question: '¿Qué puede hacer?',
      faq2Answer: 'Sobresale en generar pósters/logos con texto preciso, storyboards continuos con IDs de personajes consistentes, imágenes de productos de e-commerce realistas y edición de imágenes local compleja.',
      faq3Question: '¿Es gratis en 微鲤AI?',
      faq3Answer: '微鲤AI proporciona créditos gratuitos diarios para usuarios registrados. Para generación masiva o descargas comerciales HD sin marca de agua, ofrecemos planes de suscripción flexibles.',
      faq4Question: '¿Cuál es la calidad de imagen?',
      faq4Answer: 'Seedream 4.5 soporta salida nativa de resolución 4K con calidad de imagen delicada y lógica de iluminación rigurosa.',
      faq5Question: '¿En qué se diferencia de Flux.1 o Midjourney?',
      faq5Answer: 'Comparado con otros modelos, la mayor ventaja de Seedream 4.5 es la controlabilidad. Tiene mayor fidelidad a las imágenes de referencia y mejor rendimiento en tipografía integrada.',
      faq6Question: '¿Puedo usar las imágenes comercialmente?',
      faq6Answer: 'Sí, las imágenes generadas a través de Seedream 4.5 en 微鲤AI pueden usarse comercialmente, sujeto a los términos de servicio y leyes locales.',

      ctaTitle: 'Prueba Seedream 4.5 Ahora',
      ctaDescription: 'Usa el modelo de generación de imágenes IA más potente de ByteDance gratis',
      ctaButton: 'Comenzar a Crear',
      ctaDisclaimer: 'Sin tarjeta de crédito requerida',
  },
  fr: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - Modèle de Génération d\'Images IA Phare de ByteDance',
      pageDescription: 'Seedream 4.5 est le dernier modèle d\'image IA phare de ByteDance, axé sur le rendu typographique précis et la fusion multi-images avec sortie 4K ultra HD. Essayez-le gratuitement sur 微鲤AI.',
      pageKeywords: 'Seedream 4.5, génération d\'images IA, rendu typographique, fusion d\'images, ByteDance, qualité 4K, 微鲤AI',

      // Generator Section
      generatorTitle: 'Générateur d\'Images Seedream 4.5',
      generatorSubtitle: 'Seedream 4.5 est le dernier modèle d\'image IA phare de ByteDance. En tant que mise à niveau majeure de la série Seedream, il dépasse les limitations des modèles texte-image traditionnels, en se concentrant sur la résolution des problèmes de cohérence et de rendu de texte les plus difficiles dans la création professionnelle.',

      // Core Features
      coreFeaturesTitle: 'Fonctionnalités Principales de Seedream 4.5',
      coreFeaturesSubtitle: 'Explorez les puissantes fonctionnalités de Seedream 4.5',

      feature1Title: 'Typographie Précise et Rendu de Texte',
      feature1Desc: 'Seedream 4.5 résout le problème courant de texte illisible dans les images générées par IA. Il peut générer avec précision des titres, étiquettes et longues phrases claires et correctement orthographiées, idéal pour créer des affiches, couvertures de livres et images de produits avec logos.',

      feature2Title: 'Fusion Multi-Images et Contrôle de Cohérence',
      feature2Desc: 'Prend en charge l\'entrée simultanée de jusqu\'à 10 images de référence. Le modèle peut extraire intelligemment les caractéristiques des personnages, détails vestimentaires ou styles environnementaux de différentes images.',

      feature3Title: 'Inpainting Intelligent et Édition',
      feature3Desc: 'Contrairement au simple inpainting par masque, Seedream 4.5 comprend la logique d\'éclairage originale de la scène.',

      feature4Title: 'Qualité Cinématographique 4K Ultra HD',
      feature4Desc: 'Prend en charge la génération native d\'images haute définition 4K sans mise à l\'échelle ultérieure.',

      // How to Use
      howToUseTitle: 'Comment Utiliser Seedream 4.5 sur 微鲤AI',
      step1Title: 'Sélectionner le Modèle',
      step1Description: 'Choisissez Seedream 4.5 dans les outils d\'image IA',
      step2Title: 'Saisir le Contenu',
      step2Description: 'Entrez des prompts ou téléchargez des images de référence',
      step3Title: 'Générer l\'Image',
      step3Description: 'Cliquez sur générer et téléchargez votre image',

      youtubeTitle: 'Vidéos YouTube sur le Modèle d\'Image IA Seedream 4.5',
      xPostsTitle: 'Publications X sur le Modèle d\'Image IA Seedream 4.5',
      exploreModelsTitle: 'Explorez d\'Autres Modèles d\'Image sur 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      faqTitle: 'Questions Fréquemment Posées',
      faq1Question: 'Qu\'est-ce que Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 est un modèle avancé de génération et d\'édition d\'images IA développé par ByteDance, leader du secteur en matière de cohérence visuelle, reproduction précise du texte et sortie haute résolution.',
      faq2Question: 'Que peut-il faire?',
      faq2Answer: 'Il excelle dans la génération d\'affiches/logos avec texte précis, storyboards continus avec IDs de personnages cohérents, images de produits e-commerce réalistes et édition d\'images locale complexe.',
      faq3Question: 'Est-ce gratuit sur 微鲤AI?',
      faq3Answer: '微鲤AI fournit des crédits gratuits quotidiens pour les utilisateurs enregistrés. Pour la génération en masse ou les téléchargements commerciaux HD sans filigrane, nous proposons des plans d\'abonnement flexibles.',
      faq4Question: 'Quelle est la qualité d\'image?',
      faq4Answer: 'Seedream 4.5 prend en charge la sortie native en résolution 4K avec une qualité d\'image délicate et une logique d\'éclairage rigoureuse.',
      faq5Question: 'En quoi diffère-t-il de Flux.1 ou Midjourney?',
      faq5Answer: 'Par rapport aux autres modèles, le plus grand avantage de Seedream 4.5 est la contrôlabilité. Il a une plus grande fidélité aux images de référence et de meilleures performances en typographie intégrée.',
      faq6Question: 'Puis-je utiliser les images commercialement?',
      faq6Answer: 'Oui, les images générées via Seedream 4.5 sur 微鲤AI peuvent être utilisées commercialement, sous réserve des conditions d\'utilisation et des lois locales.',

      ctaTitle: 'Essayez Seedream 4.5 Maintenant',
      ctaDescription: 'Utilisez gratuitement le modèle de génération d\'images IA le plus puissant de ByteDance',
      ctaButton: 'Commencer à Créer',
      ctaDisclaimer: 'Pas de carte de crédit requise',
  },
  de: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - ByteDance Flaggschiff KI-Bildgenerierungsmodell',
      pageDescription: 'Seedream 4.5 ist das neueste Flaggschiff-KI-Bildmodell von ByteDance mit präzisem Typografie-Rendering und Multi-Bild-Fusion mit 4K Ultra-HD-Ausgabe. Kostenlos auf 微鲤AI testen.',
      pageKeywords: 'Seedream 4.5, KI-Bildgenerierung, Typografie-Rendering, Bildfusion, ByteDance, 4K-Qualität, 微鲤AI',

      // Generator Section
      generatorTitle: 'Seedream 4.5 Bildgenerator',
      generatorSubtitle: 'Seedream 4.5 ist das neueste Flaggschiff-KI-Bildmodell von ByteDance. Als großes Upgrade der Seedream-Serie durchbricht es die Grenzen traditioneller Text-zu-Bild-Modelle und konzentriert sich auf die Lösung der anspruchsvollsten Konsistenz- und Textrendering-Probleme in der professionellen Erstellung.',

      // Core Features
      coreFeaturesTitle: 'Seedream 4.5 Kernfunktionen',
      coreFeaturesSubtitle: 'Entdecken Sie die leistungsstarken Funktionen von Seedream 4.5',

      feature1Title: 'Präzise Typografie und Textrendering',
      feature1Desc: 'Seedream 4.5 löst das häufige Problem von unleserlichem Text in KI-generierten Bildern. Es kann präzise klare, korrekt geschriebene Titel, Labels und lange Sätze generieren, ideal für Poster, Buchcover und Produktbilder mit Logos.',

      feature2Title: 'Multi-Bild-Fusion und Konsistenzkontrolle',
      feature2Desc: 'Unterstützt die gleichzeitige Eingabe von bis zu 10 Referenzbildern. Das Modell kann intelligent Charaktermerkmale, Kleidungsdetails oder Umgebungsstile aus verschiedenen Bildern extrahieren.',

      feature3Title: 'Intelligentes Inpainting und Bearbeitung',
      feature3Desc: 'Anders als einfaches Masken-Inpainting versteht Seedream 4.5 die ursprüngliche Beleuchtungslogik der Szene.',

      feature4Title: 'Kinematische 4K Ultra-HD-Qualität',
      feature4Desc: 'Unterstützt native Generierung von 4K-Auflösungsbildern ohne Nachbearbeitung.',

      // How to Use
      howToUseTitle: 'So verwenden Sie Seedream 4.5 auf 微鲤AI',
      step1Title: 'Modell auswählen',
      step1Description: 'Wählen Sie Seedream 4.5 in den KI-Bildwerkzeugen',
      step2Title: 'Inhalt eingeben',
      step2Description: 'Geben Sie Prompts ein oder laden Sie Referenzbilder hoch',
      step3Title: 'Bild generieren',
      step3Description: 'Klicken Sie auf Generieren und laden Sie Ihr Bild herunter',

      youtubeTitle: 'YouTube-Videos über das Seedream 4.5 KI-Bildmodell',
      xPostsTitle: 'X-Beiträge über das Seedream 4.5 KI-Bildmodell',
      exploreModelsTitle: 'Entdecken Sie andere Bildmodelle auf 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      faqTitle: 'Häufig Gestellte Fragen',
      faq1Question: 'Was ist Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 ist ein fortschrittliches KI-Bildgenerierungs- und Bearbeitungsmodell von ByteDance, führend in visueller Konsistenz, präziser Textreproduktion und hochauflösender Ausgabe.',
      faq2Question: 'Was kann es?',
      faq2Answer: 'Es zeichnet sich aus bei der Generierung von Postern/Logos mit präzisem Text, kontinuierlichen Storyboards mit konsistenten Charakter-IDs, realistischen E-Commerce-Produktbildern und komplexer lokaler Bildbearbeitung.',
      faq3Question: 'Ist es auf 微鲤AI kostenlos?',
      faq3Answer: '微鲤AI bietet registrierten Nutzern tägliche kostenlose Credits. Für Massengenerierung oder kommerzielle HD-Downloads ohne Wasserzeichen bieten wir flexible Abonnementpläne.',
      faq4Question: 'Wie ist die Bildqualität?',
      faq4Answer: 'Seedream 4.5 unterstützt native 4K-Auflösungsausgabe mit feiner Bildqualität und strenger Beleuchtungslogik.',
      faq5Question: 'Wie unterscheidet es sich von Flux.1 oder Midjourney?',
      faq5Answer: 'Im Vergleich zu anderen Modellen ist der größte Vorteil von Seedream 4.5 die Kontrollierbarkeit. Es hat höhere Treue zu Referenzbildern und bessere Leistung bei eingebetteter Typografie.',
      faq6Question: 'Kann ich die Bilder kommerziell nutzen?',
      faq6Answer: 'Ja, über Seedream 4.5 auf 微鲤AI generierte Bilder können kommerziell genutzt werden, vorbehaltlich der Nutzungsbedingungen und lokaler Gesetze.',

      ctaTitle: 'Jetzt Seedream 4.5 ausprobieren',
      ctaDescription: 'Nutzen Sie kostenlos das leistungsstärkste KI-Bildgenerierungsmodell von ByteDance',
      ctaButton: 'Erstellen beginnen',
      ctaDisclaimer: 'Keine Kreditkarte erforderlich',
  },
  ru: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - Флагманская модель генерации изображений ИИ от ByteDance',
      pageDescription: 'Seedream 4.5 — новейшая флагманская модель изображений ИИ от ByteDance с точным рендерингом типографики и мультиизображением слиянием с выводом 4K Ultra HD. Попробуйте бесплатно на 微鲤AI.',
      pageKeywords: 'Seedream 4.5, генерация изображений ИИ, рендеринг типографики, слияние изображений, ByteDance, качество 4K, 微鲤AI',

      // Generator Section
      generatorTitle: 'Генератор изображений Seedream 4.5',
      generatorSubtitle: 'Seedream 4.5 — новейшая флагманская модель изображений ИИ от ByteDance. Как крупное обновление серии Seedream, она преодолевает ограничения традиционных моделей текст-в-изображение, сосредотачиваясь на решении самых сложных проблем согласованности и рендеринга текста в профессиональном творчестве.',

      // Core Features
      coreFeaturesTitle: 'Основные функции Seedream 4.5',
      coreFeaturesSubtitle: 'Изучите мощные возможности Seedream 4.5',

      feature1Title: 'Точная типографика и рендеринг текста',
      feature1Desc: 'Seedream 4.5 решает распространённую проблему нечитаемого текста в изображениях, созданных ИИ. Он может точно генерировать чёткие, правильно написанные заголовки, метки и длинные предложения, идеально подходящие для создания постеров, обложек книг и изображений продуктов с логотипами.',

      feature2Title: 'Мультиизображение слияние и контроль согласованности',
      feature2Desc: 'Поддерживает одновременный ввод до 10 референсных изображений. Модель может интеллектуально извлекать характеристики персонажей, детали одежды или стили окружения из разных изображений.',

      feature3Title: 'Интеллектуальный инпейнтинг и редактирование',
      feature3Desc: 'В отличие от простого масочного инпейнтинга, Seedream 4.5 понимает исходную логику освещения сцены.',

      feature4Title: 'Кинематографическое качество 4K Ultra HD',
      feature4Desc: 'Поддерживает нативную генерацию изображений 4K разрешения без постобработки.',

      // How to Use
      howToUseTitle: 'Как использовать Seedream 4.5 на 微鲤AI',
      step1Title: 'Выберите модель',
      step1Description: 'Выберите Seedream 4.5 в инструментах ИИ-изображений',
      step2Title: 'Введите контент',
      step2Description: 'Введите промпты или загрузите референсные изображения',
      step3Title: 'Сгенерируйте изображение',
      step3Description: 'Нажмите генерировать и скачайте изображение',

      youtubeTitle: 'Видео YouTube о модели изображений ИИ Seedream 4.5',
      xPostsTitle: 'Посты X о модели изображений ИИ Seedream 4.5',
      exploreModelsTitle: 'Изучите другие модели изображений на 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      faqTitle: 'Часто задаваемые вопросы',
      faq1Question: 'Что такое Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 — это передовая модель генерации и редактирования изображений ИИ от ByteDance, лидирующая в отрасли по визуальной согласованности, точному воспроизведению текста и высокому разрешению.',
      faq2Question: 'Что она может делать?',
      faq2Answer: 'Она отлично справляется с генерацией постеров/логотипов с точным текстом, непрерывных раскадровок с согласованными ID персонажей, реалистичных изображений товаров электронной коммерции и сложного локального редактирования изображений.',
      faq3Question: 'Это бесплатно на 微鲤AI?',
      faq3Answer: '微鲤AI предоставляет зарегистрированным пользователям ежедневные бесплатные кредиты. Для массовой генерации или коммерческих HD-загрузок без водяных знаков мы предлагаем гибкие планы подписки.',
      faq4Question: 'Какое качество изображений?',
      faq4Answer: 'Seedream 4.5 поддерживает нативный вывод в разрешении 4K с деликатным качеством изображения и строгой логикой освещения.',
      faq5Question: 'Чем он отличается от Flux.1 или Midjourney?',
      faq5Answer: 'По сравнению с другими моделями, главное преимущество Seedream 4.5 — контролируемость. Он имеет более высокую точность к референсным изображениям и лучшую производительность во встроенной типографике.',
      faq6Question: 'Могу ли я использовать изображения коммерчески?',
      faq6Answer: 'Да, изображения, созданные через Seedream 4.5 на 微鲤AI, могут использоваться коммерчески в соответствии с условиями обслуживания и местными законами.',

      ctaTitle: 'Попробуйте Seedream 4.5 сейчас',
      ctaDescription: 'Используйте бесплатно самую мощную модель генерации изображений ИИ от ByteDance',
      ctaButton: 'Начать создавать',
      ctaDisclaimer: 'Кредитная карта не требуется',
  },
  pt: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - Modelo de Geração de Imagens IA Principal da ByteDance',
      pageDescription: 'Seedream 4.5 é o mais recente modelo de imagem IA principal da ByteDance, focado em renderização tipográfica precisa e fusão de múltiplas imagens com saída 4K ultra HD. Experimente grátis no 微鲤AI.',
      pageKeywords: 'Seedream 4.5, geração de imagens IA, renderização tipográfica, fusão de imagens, ByteDance, qualidade 4K, 微鲤AI',

      // Generator Section
      generatorTitle: 'Gerador de Imagens Seedream 4.5',
      generatorSubtitle: 'Seedream 4.5 é o mais recente modelo de imagem IA principal da ByteDance. Como uma grande atualização da série Seedream, ele ultrapassa as limitações dos modelos tradicionais de texto para imagem, focando na resolução dos problemas mais desafiadores de consistência e renderização de texto na criação profissional.',

      // Core Features
      coreFeaturesTitle: 'Recursos Principais do Seedream 4.5',
      coreFeaturesSubtitle: 'Explore os recursos poderosos do Seedream 4.5',

      feature1Title: 'Tipografia Precisa e Renderização de Texto',
      feature1Desc: 'Seedream 4.5 resolve o problema comum de texto ilegível em imagens geradas por IA. Pode gerar com precisão títulos, rótulos e frases longas claras e corretamente escritas, ideal para criar pôsteres, capas de livros e imagens de produtos com logos.',

      feature2Title: 'Fusão Multi-Imagem e Controle de Consistência',
      feature2Desc: 'Suporta entrada simultânea de até 10 imagens de referência. O modelo pode extrair inteligentemente características de personagens, detalhes de roupas ou estilos ambientais de diferentes imagens.',

      feature3Title: 'Inpainting Inteligente e Edição',
      feature3Desc: 'Diferente do simples inpainting por máscara, Seedream 4.5 compreende a lógica de iluminação original da cena.',

      feature4Title: 'Qualidade Cinematográfica 4K Ultra HD',
      feature4Desc: 'Suporta geração nativa de imagens em resolução 4K sem necessidade de upscaling posterior.',

      // How to Use
      howToUseTitle: 'Como Usar Seedream 4.5 no 微鲤AI',
      step1Title: 'Selecionar Modelo',
      step1Description: 'Escolha Seedream 4.5 nas ferramentas de imagem IA',
      step2Title: 'Inserir Conteúdo',
      step2Description: 'Digite prompts ou carregue imagens de referência',
      step3Title: 'Gerar Imagem',
      step3Description: 'Clique em gerar e baixe sua imagem',

      youtubeTitle: 'Vídeos do YouTube sobre o Modelo de Imagem IA Seedream 4.5',
      xPostsTitle: 'Posts do X sobre o Modelo de Imagem IA Seedream 4.5',
      exploreModelsTitle: 'Explore Outros Modelos de Imagem no 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      faqTitle: 'Perguntas Frequentes',
      faq1Question: 'O que é Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 é um modelo avançado de geração e edição de imagens IA desenvolvido pela ByteDance, líder na indústria em consistência visual, reprodução precisa de texto e saída de alta resolução.',
      faq2Question: 'O que ele pode fazer?',
      faq2Answer: 'Ele se destaca na geração de pôsteres/logos com texto preciso, storyboards contínuos com IDs de personagens consistentes, imagens realistas de produtos de e-commerce e edição de imagens local complexa.',
      faq3Question: 'É grátis no 微鲤AI?',
      faq3Answer: '微鲤AI fornece créditos gratuitos diários para usuários registrados. Para geração em massa ou downloads comerciais HD sem marca d\'água, oferecemos planos de assinatura flexíveis.',
      faq4Question: 'Qual é a qualidade da imagem?',
      faq4Answer: 'Seedream 4.5 suporta saída nativa em resolução 4K com qualidade de imagem delicada e lógica de iluminação rigorosa.',
      faq5Question: 'Como é diferente do Flux.1 ou Midjourney?',
      faq5Answer: 'Comparado a outros modelos, a maior vantagem do Seedream 4.5 é a controlabilidade. Ele tem maior fidelidade às imagens de referência e melhor desempenho em tipografia incorporada.',
      faq6Question: 'Posso usar as imagens comercialmente?',
      faq6Answer: 'Sim, imagens geradas através do Seedream 4.5 no 微鲤AI podem ser usadas comercialmente, sujeitas aos termos de serviço e leis locais.',

      ctaTitle: 'Experimente Seedream 4.5 Agora',
      ctaDescription: 'Use gratuitamente o modelo de geração de imagens IA mais poderoso da ByteDance',
      ctaButton: 'Começar a Criar',
      ctaDisclaimer: 'Sem necessidade de cartão de crédito',
  },
  it: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - Modello di Generazione Immagini IA di Punta di ByteDance',
      pageDescription: 'Seedream 4.5 è l\'ultimo modello di immagini IA di punta di ByteDance, incentrato sul rendering tipografico preciso e sulla fusione multi-immagine con output 4K ultra HD. Provalo gratis su 微鲤AI.',
      pageKeywords: 'Seedream 4.5, generazione immagini IA, rendering tipografico, fusione immagini, ByteDance, qualità 4K, 微鲤AI',

      // Generator Section
      generatorTitle: 'Generatore di Immagini Seedream 4.5',
      generatorSubtitle: 'Seedream 4.5 è l\'ultimo modello di immagini IA di punta di ByteDance. Come importante aggiornamento della serie Seedream, supera i limiti dei tradizionali modelli testo-immagine, concentrandosi sulla risoluzione dei problemi più impegnativi di coerenza e rendering del testo nella creazione professionale.',

      // Core Features
      coreFeaturesTitle: 'Funzionalità Principali di Seedream 4.5',
      coreFeaturesSubtitle: 'Esplora le potenti funzionalità di Seedream 4.5',

      feature1Title: 'Tipografia Precisa e Rendering del Testo',
      feature1Desc: 'Seedream 4.5 risolve il problema comune del testo illeggibile nelle immagini generate dall\'IA. Può generare con precisione titoli, etichette e frasi lunghe chiare e scritte correttamente, ideale per creare poster, copertine di libri e immagini di prodotti con logo.',

      feature2Title: 'Fusione Multi-Immagine e Controllo della Coerenza',
      feature2Desc: 'Supporta l\'input simultaneo di fino a 10 immagini di riferimento. Il modello può estrarre intelligentemente caratteristiche dei personaggi, dettagli dell\'abbigliamento o stili ambientali da diverse immagini.',

      feature3Title: 'Inpainting Intelligente ed Editing',
      feature3Desc: 'A differenza del semplice inpainting con maschera, Seedream 4.5 comprende la logica di illuminazione originale della scena.',

      feature4Title: 'Qualità Cinematografica 4K Ultra HD',
      feature4Desc: 'Supporta la generazione nativa di immagini a risoluzione 4K senza necessità di upscaling successivo.',

      // How to Use
      howToUseTitle: 'Come Usare Seedream 4.5 su 微鲤AI',
      step1Title: 'Seleziona Modello',
      step1Description: 'Scegli Seedream 4.5 negli strumenti immagine IA',
      step2Title: 'Inserisci Contenuto',
      step2Description: 'Inserisci prompt o carica immagini di riferimento',
      step3Title: 'Genera Immagine',
      step3Description: 'Clicca genera e scarica la tua immagine',

      youtubeTitle: 'Video YouTube sul Modello Immagine IA Seedream 4.5',
      xPostsTitle: 'Post X sul Modello Immagine IA Seedream 4.5',
      exploreModelsTitle: 'Esplora Altri Modelli di Immagini su 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      faqTitle: 'Domande Frequenti',
      faq1Question: 'Cos\'è Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 è un modello avanzato di generazione ed editing di immagini IA sviluppato da ByteDance, leader del settore in coerenza visiva, riproduzione precisa del testo e output ad alta risoluzione.',
      faq2Question: 'Cosa può fare?',
      faq2Answer: 'Eccelle nella generazione di poster/loghi con testo preciso, storyboard continui con ID dei personaggi coerenti, immagini realistiche di prodotti e-commerce ed editing locale complesso delle immagini.',
      faq3Question: 'È gratuito su 微鲤AI?',
      faq3Answer: '微鲤AI fornisce crediti gratuiti giornalieri per gli utenti registrati. Per la generazione di massa o download commerciali HD senza filigrana, offriamo piani di abbonamento flessibili.',
      faq4Question: 'Qual è la qualità dell\'immagine?',
      faq4Answer: 'Seedream 4.5 supporta output nativo a risoluzione 4K con qualità dell\'immagine delicata e logica di illuminazione rigorosa.',
      faq5Question: 'Come si differenzia da Flux.1 o Midjourney?',
      faq5Answer: 'Rispetto ad altri modelli, il più grande vantaggio di Seedream 4.5 è la controllabilità. Ha maggiore fedeltà alle immagini di riferimento e migliori prestazioni nella tipografia incorporata.',
      faq6Question: 'Posso usare le immagini commercialmente?',
      faq6Answer: 'Sì, le immagini generate tramite Seedream 4.5 su 微鲤AI possono essere utilizzate commercialmente, nel rispetto dei termini di servizio e delle leggi locali.',

      ctaTitle: 'Prova Seedream 4.5 Ora',
      ctaDescription: 'Usa gratuitamente il più potente modello di generazione immagini IA di ByteDance',
      ctaButton: 'Inizia a Creare',
      ctaDisclaimer: 'Nessuna carta di credito richiesta',
  },
  ar: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - نموذج توليد الصور بالذكاء الاصطناعي الرائد من ByteDance',
      pageDescription: 'Seedream 4.5 هو أحدث نموذج صور بالذكاء الاصطناعي من ByteDance، يركز على عرض الخطوط بدقة ودمج الصور المتعددة مع إخراج 4K فائق الدقة. جربه مجاناً على 微鲤AI.',
      pageKeywords: 'Seedream 4.5, توليد صور الذكاء الاصطناعي, عرض الخطوط, دمج الصور, ByteDance, جودة 4K, 微鲤AI',

      // Generator Section
      generatorTitle: 'مولد الصور Seedream 4.5',
      generatorSubtitle: 'Seedream 4.5 هو أحدث نموذج صور بالذكاء الاصطناعي الرائد من ByteDance. كترقية رئيسية لسلسلة Seedream، فإنه يتجاوز قيود نماذج النص إلى الصورة التقليدية، مع التركيز على حل أصعب مشاكل الاتساق وعرض النص في الإبداع المهني.',

      // Core Features
      coreFeaturesTitle: 'الميزات الأساسية لـ Seedream 4.5',
      coreFeaturesSubtitle: 'استكشف الميزات القوية لـ Seedream 4.5',

      feature1Title: 'طباعة دقيقة وعرض النص',
      feature1Desc: 'يحل Seedream 4.5 المشكلة الشائعة للنص غير المقروء في الصور المولدة بالذكاء الاصطناعي. يمكنه توليد عناوين وتسميات وجمل طويلة واضحة ومكتوبة بشكل صحيح بدقة، مثالي لإنشاء الملصقات وأغلفة الكتب وصور المنتجات مع الشعارات.',

      feature2Title: 'دمج الصور المتعددة والتحكم في الاتساق',
      feature2Desc: 'يدعم الإدخال المتزامن لما يصل إلى 10 صور مرجعية. يمكن للنموذج استخراج خصائص الشخصيات أو تفاصيل الملابس أو أنماط البيئة بذكاء من صور مختلفة.',

      feature3Title: 'الرسم الذكي والتحرير',
      feature3Desc: 'على عكس الرسم البسيط بالقناع، يفهم Seedream 4.5 منطق الإضاءة الأصلي للمشهد.',

      feature4Title: 'جودة سينمائية 4K فائقة الدقة',
      feature4Desc: 'يدعم التوليد الأصلي لصور بدقة 4K دون الحاجة إلى تكبير لاحق.',

      // How to Use
      howToUseTitle: 'كيفية استخدام Seedream 4.5 على 微鲤AI',
      step1Title: 'اختر النموذج',
      step1Description: 'اختر Seedream 4.5 في أدوات الصور بالذكاء الاصطناعي',
      step2Title: 'أدخل المحتوى',
      step2Description: 'أدخل المطالبات أو حمّل الصور المرجعية',
      step3Title: 'ولّد الصورة',
      step3Description: 'انقر على توليد وحمّل صورتك',

      youtubeTitle: 'فيديوهات يوتيوب حول نموذج الصور بالذكاء الاصطناعي Seedream 4.5',
      xPostsTitle: 'منشورات X حول نموذج الصور بالذكاء الاصطناعي Seedream 4.5',
      exploreModelsTitle: 'استكشف نماذج الصور الأخرى على 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      faqTitle: 'الأسئلة الشائعة',
      faq1Question: 'ما هو Seedream 4.5؟',
      faq1Answer: 'Seedream 4.5 هو نموذج متقدم لتوليد وتحرير الصور بالذكاء الاصطناعي من ByteDance، رائد في الصناعة في الاتساق البصري وإعادة إنتاج النص بدقة والإخراج عالي الدقة.',
      faq2Question: 'ماذا يمكنه أن يفعل؟',
      faq2Answer: 'يتفوق في توليد الملصقات/الشعارات بنص دقيق، والقصص المصورة المستمرة بمعرفات شخصيات متسقة، وصور منتجات التجارة الإلكترونية الواقعية، وتحرير الصور المحلي المعقد.',
      faq3Question: 'هل هو مجاني على 微鲤AI؟',
      faq3Answer: 'يوفر 微鲤AI أرصدة مجانية يومية للمستخدمين المسجلين. للتوليد بالجملة أو التنزيلات التجارية عالية الدقة بدون علامة مائية، نقدم خطط اشتراك مرنة.',
      faq4Question: 'ما هي جودة الصورة؟',
      faq4Answer: 'يدعم Seedream 4.5 الإخراج الأصلي بدقة 4K مع جودة صورة دقيقة ومنطق إضاءة صارم.',
      faq5Question: 'كيف يختلف عن Flux.1 أو Midjourney؟',
      faq5Answer: 'مقارنة بالنماذج الأخرى، أكبر ميزة لـ Seedream 4.5 هي قابلية التحكم. لديه دقة أعلى للصور المرجعية وأداء أفضل في الطباعة المدمجة.',
      faq6Question: 'هل يمكنني استخدام الصور تجارياً؟',
      faq6Answer: 'نعم، يمكن استخدام الصور المولدة عبر Seedream 4.5 على 微鲤AI تجارياً، وفقاً لشروط الخدمة والقوانين المحلية.',

      ctaTitle: 'جرب Seedream 4.5 الآن',
      ctaDescription: 'استخدم مجاناً أقوى نموذج توليد صور بالذكاء الاصطناعي من ByteDance',
      ctaButton: 'ابدأ الإنشاء',
      ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
  },
  tw: {
      pageTitle: 'Seedream 4.5 - 字節跳動旗艦級 AI 圖像生成模型',
      pageDescription: 'Seedream 4.5 是字節跳動最新推出的旗艦級 AI 圖像模型，專注於精準文字渲染與多圖融合，支援4K超清畫質輸出。立即在 微鲤AI 免費體驗。',
      generatorTitle: 'Seedream 4.5 圖像生成器',
      generatorSubtitle: 'Seedream 4.5 是字節跳動的最新旗艦級 AI 圖像模型。作為 Seedream 系列的重大升級版，它突破了傳統文生圖模型的限制，專注於解決專業創作中最棘手的「一致性」與「文本渲染」難題。',
      coreFeaturesTitle: 'Seedream 4.5 核心功能',
      coreFeaturesSubtitle: '探索 Seedream 4.5 的強大功能',
      feature1Title: '精準排版與文字渲染',
      feature1Desc: 'Seedream 4.5 解決了 AI 生成圖片中文字亂碼的通病。它能精準地在圖像中生成清晰、拼寫正確的標題、標籤和長句，非常適合製作海報、書籍封面及帶有 Logo 的產品圖。',
      feature2Title: '多圖融合與一致性控制',
      feature2Desc: '支援同時輸入多達 10 張參考圖像，模型能智能提取不同圖片中的人物特徵、服裝細節或環境風格，並將它們完美融合到一張新圖中。',
      feature3Title: '智能局部重繪與編輯',
      feature3Desc: '不同於簡單的遮罩重繪，Seedream 4.5 能理解畫面原本的光影邏輯。',
      feature4Title: '電影級 4K 超清畫質',
      feature4Desc: '原生支援生成 4K 解析度的高細節圖像，無需後期放大。',
      howToUseTitle: '如何在 微鲤AI 上使用 Seedream 4.5',
      step1Title: '選擇模型',
      step1Description: '在 AI 圖像工具中選擇 Seedream 4.5',
      step2Title: '輸入內容',
      step2Description: '輸入提示詞或上傳參考圖像',
      step3Title: '生成圖像',
      step3Description: '點擊生成並下載您的圖像',
      youtubeTitle: '關於 Seedream 4.5 AI 圖像模型的 YouTube 影片',
      xPostsTitle: '關於 Seedream 4.5 AI 圖像模型的 X 貼文',
      exploreModelsTitle: '探索 微鲤AI 上的其他圖像模型',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',
      faqTitle: '常見問題',
      faq1Question: 'Seedream 4.5 是什麼？',
      faq1Answer: 'Seedream 4.5 是字節跳動開發的先進 AI 圖像生成與編輯模型，在保持畫面一致性、精準還原文字以及高解析度輸出方面處於行業領先地位。',
      faq2Question: '它主要能做什麼？',
      faq2Answer: '它最擅長生成帶有準確文字的海報/Logo、保持人物 ID 一致的連續分鏡、逼真的電商產品圖，以及進行複雜的局部圖像編輯。',
      faq3Question: '在 微鲤AI 上使用是免費的嗎？',
      faq3Answer: '微鲤AI 為註冊用戶提供每日免費的積分額度。如需大量生成或商用高清無水印下載，我們提供靈活的會員訂閱計劃。',
      faq4Question: '生成圖片的品質如何？',
      faq4Answer: 'Seedream 4.5 支援原生 4K 解析度輸出，畫質細膩，光影邏輯嚴謹。',
      faq5Question: '它和 Flux.1 或 Midjourney 有什麼區別？',
      faq5Answer: '相比其他模型，Seedream 4.5 最大的優勢在於可控性。它對參考圖的還原度更高，並且在生成圖片內嵌文字方面表現更為出色。',
      faq6Question: '我可以將生成的圖片用於商業用途嗎？',
      faq6Answer: '是的，通過 微鲤AI 平台生成的 Seedream 4.5 圖片，在符合平台服務條款和當地法律法規的前提下，您擁有其商業使用權。',
      ctaTitle: '立即體驗 Seedream 4.5',
      ctaDescription: '免費使用字節跳動最強大的 AI 圖像生成模型',
      ctaButton: '開始創作',
      ctaDisclaimer: '無需信用卡',
  },
  pl: {
      pageTitle: 'Seedream 4.5 - Flagowy model generowania obrazów AI od ByteDance',
      pageDescription: 'Seedream 4.5 to najnowszy flagowy model obrazów AI od ByteDance, skupiony na precyzyjnym renderowaniu typografii i fuzji wielu obrazów z wyjściem 4K ultra HD. Wypróbuj za darmo na 微鲤AI.',
      generatorTitle: 'Generator obrazów Seedream 4.5',
      generatorSubtitle: 'Seedream 4.5 to najnowszy flagowy model obrazów AI od ByteDance. Jako główna aktualizacja serii Seedream, przełamuje ograniczenia tradycyjnych modeli tekst-obraz, koncentrując się na rozwiązywaniu najtrudniejszych problemów spójności i renderowania tekstu w profesjonalnym tworzeniu.',
      coreFeaturesTitle: 'Główne funkcje Seedream 4.5',
      coreFeaturesSubtitle: 'Odkryj potężne możliwości Seedream 4.5',
      feature1Title: 'Precyzyjna typografia i renderowanie tekstu',
      feature1Desc: 'Seedream 4.5 rozwiązuje powszechny problem nieczytelnego tekstu w obrazach generowanych przez AI. Może precyzyjnie generować jasne, poprawnie napisane tytuły, etykiety i długie zdania, idealne do tworzenia plakatów, okładek książek i obrazów produktów z logo.',
      feature2Title: 'Fuzja wielu obrazów i kontrola spójności',
      feature2Desc: 'Obsługuje jednoczesne wprowadzanie do 10 obrazów referencyjnych. Model może inteligentnie wyodrębniać cechy postaci, szczegóły ubrań lub style środowiska z różnych obrazów.',
      feature3Title: 'Inteligentne inpainting i edycja',
      feature3Desc: 'W przeciwieństwie do prostego inpaintingu z maską, Seedream 4.5 rozumie oryginalną logikę oświetlenia sceny.',
      feature4Title: 'Kinowa jakość 4K Ultra HD',
      feature4Desc: 'Obsługuje natywne generowanie obrazów w rozdzielczości 4K bez późniejszego skalowania.',
      howToUseTitle: 'Jak używać Seedream 4.5 na 微鲤AI',
      step1Title: 'Wybierz model',
      step1Description: 'Wybierz Seedream 4.5 w narzędziach obrazów AI',
      step2Title: 'Wprowadź treść',
      step2Description: 'Wprowadź prompt lub prześlij obrazy referencyjne',
      step3Title: 'Wygeneruj obraz',
      step3Description: 'Kliknij generuj i pobierz swój obraz',
      youtubeTitle: 'Filmy YouTube o modelu obrazów AI Seedream 4.5',
      xPostsTitle: 'Posty X o modelu obrazów AI Seedream 4.5',
      exploreModelsTitle: 'Odkryj inne modele obrazów na 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',
      faqTitle: 'Najczęściej zadawane pytania',
      faq1Question: 'Czym jest Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 to zaawansowany model generowania i edycji obrazów AI opracowany przez ByteDance, wiodący w branży pod względem spójności wizualnej, precyzyjnej reprodukcji tekstu i wyjścia w wysokiej rozdzielczości.',
      faq2Question: 'Co może zrobić?',
      faq2Answer: 'Wyróżnia się w generowaniu plakatów/logo z dokładnym tekstem, ciągłych storyboardów ze spójnymi ID postaci, realistycznych obrazów produktów e-commerce i złożonej lokalnej edycji obrazów.',
      faq3Question: 'Czy jest darmowy na 微鲤AI?',
      faq3Answer: '微鲤AI zapewnia codzienne darmowe kredyty dla zarejestrowanych użytkowników. Do masowego generowania lub komercyjnych pobrań HD bez znaku wodnego oferujemy elastyczne plany subskrypcji.',
      faq4Question: 'Jaka jest jakość obrazu?',
      faq4Answer: 'Seedream 4.5 obsługuje natywne wyjście w rozdzielczości 4K z delikatną jakością obrazu i rygorystyczną logiką oświetlenia.',
      faq5Question: 'Czym różni się od Flux.1 lub Midjourney?',
      faq5Answer: 'W porównaniu z innymi modelami, największą zaletą Seedream 4.5 jest kontrolowalność. Ma wyższą wierność obrazom referencyjnym i lepszą wydajność w osadzonej typografii.',
      faq6Question: 'Czy mogę używać obrazów komercyjnie?',
      faq6Answer: 'Tak, obrazy wygenerowane przez Seedream 4.5 na 微鲤AI mogą być używane komercyjnie, z zastrzeżeniem warunków korzystania i lokalnych przepisów.',
      ctaTitle: 'Wypróbuj Seedream 4.5 teraz',
      ctaDescription: 'Używaj za darmo najpotężniejszego modelu generowania obrazów AI od ByteDance',
      ctaButton: 'Zacznij tworzyć',
      ctaDisclaimer: 'Nie wymaga karty kredytowej',
      },
    th: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - โมเดลสร้างภาพ AI เรือธงของ ByteDance',
      pageDescription:
        'Seedream 4.5 คือโมเดลภาพ AI เรือธงล่าสุดจาก ByteDance โดดเด่นด้านการเรนเดอร์ตัวอักษรอย่างแม่นยำและการผสานหลายภาพ พร้อมเอาต์พุต 4K Ultra HD ลองใช้ฟรีบน 微鲤AI',
      pageKeywords:
        'Seedream 4.5, การสร้างภาพ AI, การเรนเดอร์ตัวอักษร, การผสานหลายภาพ, ByteDance, คุณภาพ 4K, 微鲤AI',
      ogTitle: 'Seedream 4.5 เครื่องมือสร้างภาพ AI | 微鲤AI',
      ogDescription:
        'Seedream 4.5 โมเดลภาพ AI เรือธงของ ByteDance ที่แม่นยำด้านตัวอักษรและการผสานหลายภาพ',
      twitterTitle: 'Seedream 4.5 - การสร้างภาพ AI เรือธงของ ByteDance',
      twitterDescription:
        'สัมผัสพลังการสร้างภาพของ Seedream 4.5 ตัวอักษรคมชัด คุณภาพ 4K Ultra HD',

      // Generator Section
      generatorTitle: 'เครื่องมือสร้างภาพ Seedream 4.5',
      generatorSubtitle:
        'Seedream 4.5 คือโมเดลภาพ AI เรือธงล่าสุดจาก ByteDance เป็นการอัปเกรดครั้งใหญ่ของซีรีส์ Seedream ที่ก้าวข้ามข้อจำกัดของโมเดลข้อความ‑เป็น‑ภาพแบบเดิม โดยเน้นแก้ปัญหาความสม่ำเสมอและการเรนเดอร์ข้อความที่ท้าทายที่สุดในการสร้างงานระดับมืออาชีพ โมเดลนี้โดดเด่นด้วยความสามารถในการผสานหลายภาพ การสร้างตัวอักษรอย่างแม่นยำ และการควบคุมรายละเอียดแสงเงาแบบภาพยนตร์ เหมาะสำหรับดีไซเนอร์ ผู้ทำอีคอมเมิร์ซ และผู้สร้างแบรนด์ ลองใช้ความสามารถระดับมืออาชีพของ Seedream 4.5 ได้ฟรีบน 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'ฟีเจอร์หลักของ Seedream 4.5',
      coreFeaturesSubtitle:
        'สำรวจฟีเจอร์อันทรงพลังของ Seedream 4.5 และเริ่มการสร้างภาพ AI ระดับมืออาชีพ',

      feature1Title: 'การจัดวางตัวอักษรและเรนเดอร์ข้อความอย่างแม่นยำ',
      feature1Desc:
        'Seedream 4.5 แก้ปัญหาข้อความมั่วในภาพที่สร้างโดย AI ได้อย่างมีประสิทธิภาพ สามารถสร้างหัวข้อ ป้าย และประโยคยาวที่ชัดเจนและสะกดถูกต้อง เหมาะสำหรับโปสเตอร์ ปกหนังสือ และภาพสินค้าแบบมีโลโก้',
      feature1Alt: 'ตัวอย่างการเรนเดอร์ตัวอักษรของ Seedream 4.5',

      feature2Title: 'การผสานหลายภาพและควบคุมความสม่ำเสมอ',
      feature2Desc:
        'รองรับภาพอ้างอิงพร้อมกันสูงสุด 10 ภาพ โมเดลจะดึงคุณลักษณะตัวละคร รายละเอียดเสื้อผ้า หรือสไตล์สภาพแวดล้อมจากภาพต่าง ๆ แล้วผสานเป็นภาพใหม่ได้อย่างลงตัว พร้อมรักษา ID ตัวละครและองค์ประกอบหลักให้คงที่ข้ามฉาก',
      feature2Alt: 'ตัวอย่างการผสานหลายภาพของ Seedream 4.5',

      feature3Title: 'การอินเพนต์และแก้ไขแบบอัจฉริยะ',
      feature3Desc:
        'ต่างจากการอินเพนต์ด้วยมาสก์แบบพื้นฐาน Seedream 4.5 เข้าใจตรรกะแสงเดิมของฉาก เมื่อสั่ง “เปลี่ยนเสื้อผ้า” หรือ “เปลี่ยนพื้นหลัง” โมเดลจะปรับแสงเงาและแสงสะท้อนรอบ ๆ ให้กลมกลืนอย่างไร้รอยต่อ',
      feature3Alt: 'ตัวอย่างการอินเพนต์อัจฉริยะของ Seedream 4.5',

      feature4Title: 'คุณภาพ 4K Ultra HD ระดับภาพยนตร์',
      feature4Desc:
        'รองรับการสร้างภาพ 4K แบบเนทีฟโดยไม่ต้องอัปสเกลหลังบ้าน พร้อมเอนจินเรนเดอร์ฟิสิกส์ที่จำลองระยะชัดลึก กลุ่มวัสดุ (เช่น รูขุมขน เส้นใยผ้า) และการกระเจิงแสงที่ซับซ้อนได้อย่างสมจริง',
      feature4Alt: 'ตัวอย่างคุณภาพ 4K ของ Seedream 4.5',

      // How to Use
      howToUseTitle: 'วิธีใช้ Seedream 4.5 บน 微鲤AI',
      howToUseSubtitle: 'เริ่มได้ใน 3 ขั้นตอน',

      step1Title: 'เลือกโมเดล',
      step1Description: 'เลือก Seedream 4.5 ในเครื่องมือภาพ AI',

      step2Title: 'ป้อนเนื้อหา',
      step2Description: 'พิมพ์พรอมต์หรืออัปโหลดภาพอ้างอิง',

      step3Title: 'สร้างภาพ',
      step3Description: 'คลิกสร้างและดาวน์โหลดภาพของคุณ',

      // YouTube Section
      youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลภาพ AI Seedream 4.5',

      // X Posts Section
      xPostsTitle: 'โพสต์ X เกี่ยวกับโมเดลภาพ AI Seedream 4.5',

      // Explore Models
      exploreModelsTitle: 'สำรวจโมเดลภาพอื่น ๆ บน 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      // FAQ
      faqTitle: 'คำถามที่พบบ่อย',

      faq1Question: 'Seedream 4.5 คืออะไร?',
      faq1Answer:
        'Seedream 4.5 คือโมเดลสร้างและแก้ไขภาพ AI ขั้นสูงจาก ByteDance ที่โดดเด่นด้านความสม่ำเสมอของภาพ การสร้างข้อความอย่างแม่นยำ และเอาต์พุตความละเอียดสูง',

      faq2Question: 'ทำอะไรได้บ้าง?',
      faq2Answer:
        'เด่นในการสร้างโปสเตอร์/โลโก้ที่มีข้อความถูกต้อง สตอรี่บอร์ดต่อเนื่องที่คง ID ตัวละคร ภาพสินค้าอีคอมเมิร์ซที่สมจริง และการแก้ไขเฉพาะจุดแบบซับซ้อน (เช่น เปลี่ยนเสื้อผ้าหรือพื้นหลัง)',

      faq3Question: 'ใช้งานบน 微鲤AI ฟรีไหม?',
      faq3Answer:
        '微鲤AI มีเครดิตฟรีรายวันให้ผู้ใช้ที่ลงทะเบียนได้ลอง Seedream 4.5 หากต้องการสร้างจำนวนมากหรือดาวน์โหลดเชิงพาณิชย์แบบ HD ไม่มีลายน้ำ เรามีแพ็กเกจสมัครสมาชิกที่ยืดหยุ่น',

      faq4Question: 'คุณภาพภาพเป็นอย่างไร?',
      faq4Answer:
        'Seedream 4.5 รองรับเอาต์พุต 4K แบบเนทีฟ คุณภาพภาพละเอียดและตรรกะแสงเงาแม่นยำ โดยเฉพาะพื้นผิวผิวหนังและวัสดุ (เช่น โลหะ กระจก) ระดับภาพถ่ายเชิงพาณิชย์',

      faq5Question: 'ต่างจาก Flux.1 หรือ Midjourney อย่างไร?',
      faq5Answer:
        'เมื่อเทียบกับโมเดลอื่น จุดเด่นที่สุดของ Seedream 4.5 คือ “การควบคุมได้” มีความเที่ยงตรงต่อภาพอ้างอิงสูงกว่า (การผสานหลายภาพ) และทำได้ดีกว่าในการสร้างข้อความฝังในภาพ จึงเหมาะกับงานออกแบบเชิงพาณิชย์มากกว่า',

      faq6Question: 'ใช้ภาพที่สร้างเชิงพาณิชย์ได้ไหม?',
      faq6Answer:
        'ได้ ภาพที่สร้างผ่าน Seedream 4.5 บน 微鲤AI สามารถใช้เชิงพาณิชย์ได้ โดยต้องเป็นไปตามเงื่อนไขการให้บริการของแพลตฟอร์มและกฎหมายท้องถิ่น',

      // CTA Section
      ctaTitle: 'ลองใช้ Seedream 4.5 ตอนนี้',
      ctaDescription:
        'ใช้งานโมเดลสร้างภาพ AI ที่ทรงพลังที่สุดของ ByteDance ได้ฟรี',
      ctaButton: 'เริ่มสร้างสรรค์',
      ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',
    },
    da: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - ByteDance flagskibs AI-billedmodel',
      pageDescription:
        'Seedream 4.5 er ByteDances nyeste flagskibs‑AI‑billedmodel med fokus på præcis typografirendering og multi‑billed‑fusion med 4K Ultra HD‑output. Prøv den gratis på 微鲤AI.',
      pageKeywords:
        'Seedream 4.5, AI-billedgenerering, typografirendering, multi-billed-fusion, ByteDance, 4K-kvalitet, 微鲤AI',
      ogTitle: 'Seedream 4.5 AI-billedgenerator | 微鲤AI',
      ogDescription:
        'Seedream 4.5 ByteDances flagskibs‑AI‑billedmodel med præcis typografi og multi‑billed‑fusion',
      twitterTitle: 'Seedream 4.5 - ByteDance flagskibs AI-billedgenerering',
      twitterDescription:
        'Oplev Seedream 4.5: kraftfuld billedgenerering, præcis typografi og 4K Ultra HD‑kvalitet',

      // Generator Section
      generatorTitle: 'Seedream 4.5 billedgenerator',
      generatorSubtitle:
        'Seedream 4.5 billedgenerator er ByteDances nyeste flagskibs‑AI‑billedmodel. Som en stor opgradering af Seedream‑serien bryder den begrænsningerne i traditionelle tekst‑til‑billede‑modeller og fokuserer på de sværeste problemer med konsistens og tekstrendering i professionel produktion. Modellen er kendt for stærk multi‑billed‑fusion, præcis typografisk generering og filmisk kontrol af lysdetaljer — ideel for designere, e‑handel og brandskabere. Prøv Seedream 4.5’s professionelle kreativitet gratis på 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Seedream 4.5 kernefunktioner',
      coreFeaturesSubtitle:
        'Udforsk de kraftfulde funktioner i Seedream 4.5 og start din professionelle AI‑billedrejse',

      feature1Title: 'Præcis typografi og tekstrendering',
      feature1Desc:
        'Seedream 4.5 løser det velkendte problem med forvredet tekst i AI‑genererede billeder. Den kan generere klare, korrekt stavede titler, labels og lange sætninger i billeder — perfekt til plakater, bogomslag og produktbilleder med logo.',
      feature1Alt: 'Seedream 4.5 eksempel på præcis typografi',

      feature2Title: 'Multi‑billed‑fusion og konsistenskontrol',
      feature2Desc:
        'Understøtter op til 10 referencebilleder samtidig. Modellen udtrækker intelligent karaktertræk, tøjdetaljer eller miljøstil fra forskellige billeder og blender dem perfekt i ét nyt billede, så karakter‑ID og kerneelementer forbliver konsistente på tværs af scener.',
      feature2Alt: 'Seedream 4.5 eksempel på multi‑billed‑fusion',

      feature3Title: 'Intelligent inpainting og redigering',
      feature3Desc:
        'I modsætning til simpel maske‑inpainting forstår Seedream 4.5 scenens originale lyslogik. Når du beder om at “skifte tøj” eller “skifte baggrund”, udskifter den ikke kun objektet, men justerer også reflekslys og skygger i omgivelserne, så ændringen bliver sømløs.',
      feature3Alt: 'Seedream 4.5 eksempel på intelligent inpainting',

      feature4Title: 'Filmisk 4K Ultra HD‑kvalitet',
      feature4Desc:
        'Understøtter native generering af 4K‑billeder med høj detaljegrad uden efterfølgende opskalering. Den forbedrede fysik‑rendering kan simulere realistisk dybdeskarphed, materialeteksturer (fx hudporer, stof‑fibre) og komplekse lys‑spredningseffekter.',
      feature4Alt: 'Seedream 4.5 eksempel på 4K‑kvalitet',

      // How to Use
      howToUseTitle: 'Sådan bruger du Seedream 4.5 på 微鲤AI',
      howToUseSubtitle: 'Kom i gang i tre trin',

      step1Title: 'Vælg model',
      step1Description: 'Vælg Seedream 4.5 i AI‑billedværktøjerne',

      step2Title: 'Indtast indhold',
      step2Description: 'Indtast prompts eller upload referencebilleder',

      step3Title: 'Generér billede',
      step3Description: 'Klik på generér og download dit billede',

      // YouTube Section
      youtubeTitle: 'YouTube‑videoer om Seedream 4.5 AI‑billedmodel',

      // X Posts Section
      xPostsTitle: 'X‑opslag om Seedream 4.5 AI‑billedmodel',

      // Explore Models
      exploreModelsTitle: 'Udforsk andre billedmodeller på 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      // FAQ
      faqTitle: 'Ofte stillede spørgsmål',

      faq1Question: 'Hvad er Seedream 4.5?',
      faq1Answer:
        'Seedream 4.5 er en avanceret AI‑model til billedgenerering og redigering udviklet af ByteDance, førende i visuel konsistens, præcis tekstgengivelse og høj opløsning.',

      faq2Question: 'Hvad kan den?',
      faq2Answer:
        'Den er stærk til plakater/logoer med korrekt tekst, kontinuerlige storyboards med konsistente karakter‑ID’er, realistiske e‑commerce‑produktbilleder samt kompleks lokal billedredigering (fx skifte tøj eller baggrund).',

      faq3Question: 'Er den gratis at bruge på 微鲤AI?',
      faq3Answer:
        '微鲤AI giver daglige gratis credits til registrerede brugere for at prøve Seedream 4.5. Til masseproduktion eller kommercielle HD‑downloads uden vandmærke tilbyder vi fleksible abonnementer.',

      faq4Question: 'Hvordan er billedkvaliteten?',
      faq4Answer:
        'Seedream 4.5 understøtter native 4K‑output med fin detaljegrad og stringent lyslogik — på kommercielt fotoniveau for hudtekstur og materialer (fx metal, glas).',

      faq5Question: 'Hvordan adskiller den sig fra Flux.1 eller Midjourney?',
      faq5Answer:
        'Sammenlignet med andre modeller er Seedream 4.5’s største fordel kontrol. Den har højere troværdighed i referencebilleder (multi‑billed‑fusion) og bedre indlejret typografi, hvilket gør den mere velegnet til kommercielt design.',

      faq6Question: 'Kan jeg bruge genererede billeder kommercielt?',
      faq6Answer:
        'Ja. Billeder genereret med Seedream 4.5 på 微鲤AI kan bruges kommercielt, underlagt platformens vilkår og lokale love.',

      // CTA Section
      ctaTitle: 'Prøv Seedream 4.5 nu',
      ctaDescription:
        'Brug ByteDances mest kraftfulde AI‑billedmodel gratis',
      ctaButton: 'Begynd at skabe',
      ctaDisclaimer: 'Ingen kreditkort kræves',
    },
    no: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - ByteDance flaggskip AI-bildegenereringsmodell',
      pageDescription: 'Seedream 4.5 er ByteDance sin nyeste flaggskip AI-bildemodell, med fokus på presis typografi og multi-bilde-fusjon i 4K ultra-HD. Prøv gratis på 微鲤AI.',
      pageKeywords: 'Seedream 4.5, AI-bildegenerering, typografirendering, multi-bilde-fusjon, ByteDance, 4K-kvalitet, 微鲤AI',
      ogTitle: 'Seedream 4.5 AI-bildegenerator | 微鲤AI',
      ogDescription: 'Seedream 4.5, ByteDance sin flaggskip AI-bildemodell med presis typografi og multi-bilde-fusjon',
      twitterTitle: 'Seedream 4.5 - ByteDance flaggskip AI-bildegenerering',
      twitterDescription: 'Opplev kraftig bildegenerering i Seedream 4.5, presis typografi og 4K ultra-HD-kvalitet',

      // Generator Section
      generatorTitle: 'Seedream 4.5 bildegenerator',
      generatorSubtitle: 'Seedream 4.5 er ByteDance sin nyeste flaggskip AI-bildemodell. Som en stor oppgradering i Seedream-serien bryter den begrensninger i tradisjonelle tekst-til-bilde-modeller ved å løse de mest krevende konsistens- og tekstrenderingsproblemene i profesjonell produksjon. Modellen er kjent for imponerende multi-bilde-fusjon, presis typografisk generering og filmatisk kontroll av lysdetaljer, noe som gjør den ideell for designere, e‑handel og merkevarebyggere. Prøv Seedream 4.5 sine profesjonelle kreative evner gratis på 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Seedream 4.5 kjernefunksjoner',
      coreFeaturesSubtitle: 'Utforsk de kraftige funksjonene i Seedream 4.5 og start din profesjonelle AI-bilde-reise',

      feature1Title: 'Presis typografi og tekstrendering',
      feature1Desc: 'Seedream 4.5 løser det vanlige problemet med uleselig tekst i AI-genererte bilder. Den kan generere klare, korrekt stavede titler, etiketter og lange setninger i bilder, ideelt for plakater, bokomslag og produktbilder med logoer.',
      feature1Alt: 'Seedream 4.5 eksempel på presis typografi',

      feature2Title: 'Multi-bilde-fusjon og konsistenskontroll',
      feature2Desc: 'Støtter opptil 10 referansebilder samtidig. Modellen kan hente ut karaktertrekk, klesdetaljer eller miljøstiler fra ulike bilder og smelte dem perfekt sammen, slik at karakter-ID og kjerneelementer holder seg svært konsistente på tvers av scener.',
      feature2Alt: 'Seedream 4.5 multi-bilde-fusjon eksempel',

      feature3Title: 'Intelligent inpainting og redigering',
      feature3Desc: 'I motsetning til enkel maskering forstår Seedream 4.5 den opprinnelige lyslogikken i scenen. Når du ber om å "skifte klær" eller "endre bakgrunn", bytter den ikke bare objektet, men justerer også reflektert lys og skygger i omgivelsene slik at endringen blir sømløs.',
      feature3Alt: 'Seedream 4.5 intelligent inpainting eksempel',

      feature4Title: 'Filmatisk 4K ultra-HD-kvalitet',
      feature4Desc: 'Støtter 4K-oppløsning med høy detaljgrad uten etterbehandling. Den forbedrede fysikk-renderingsmotoren kan simulere kameradybdeskarphet, materialteksturer (som hudporer og stoffibre) og komplekse lysspredningseffekter.',
      feature4Alt: 'Seedream 4.5 4K-kvalitet eksempel',

      // How to Use
      howToUseTitle: 'Slik bruker du Seedream 4.5 på 微鲤AI',
      howToUseSubtitle: 'Kom i gang på tre enkle trinn',

      step1Title: 'Velg modell',
      step1Description: 'Velg Seedream 4.5 i AI-bildeverktøyene',

      step2Title: 'Skriv inn innhold',
      step2Description: 'Skriv inn prompts eller last opp referansebilder',

      step3Title: 'Generer bilde',
      step3Description: 'Klikk generer og last ned bildet ditt',

      // YouTube Section
      youtubeTitle: 'YouTube-videoer om Seedream 4.5 AI-bildemodell',

      // X Posts Section
      xPostsTitle: 'X-innlegg om Seedream 4.5 AI-bildemodell',

      // Explore Models
      exploreModelsTitle: 'Utforsk andre bildemodeller på 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      // FAQ
      faqTitle: 'Ofte stilte spørsmål',

      faq1Question: 'Hva er Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 er en avansert AI-modell for bildegenerering og -redigering utviklet av ByteDance, ledende på visuell konsistens, presis tekstreproduksjon og høy oppløsning.',

      faq2Question: 'Hva kan den gjøre?',
      faq2Answer: 'Den er sterk på plakater/logoer med korrekt tekst, kontinuerlige storyboards med konsistente karakter-ID-er, realistiske e‑commerce-produktbilder og kompleks lokal bilde­redigering (som å skifte klær eller bakgrunn).',

      faq3Question: 'Er den gratis å bruke på 微鲤AI?',
      faq3Answer: '微鲤AI gir daglige gratis kreditter til registrerte brukere for å prøve Seedream 4.5. For masseproduksjon eller kommersielle HD-nedlastinger uten vannmerke tilbyr vi fleksible abonnementer.',

      faq4Question: 'Hvordan er bildekvaliteten?',
      faq4Answer: 'Seedream 4.5 støtter native 4K-utdata med fin detaljering og streng lyslogikk, og oppnår kommersiell fotokvalitet i hudtekstur og materialer (som metall og glass).',

      faq5Question: 'Hva er forskjellen fra Flux.1 eller Midjourney?',
      faq5Answer: 'Sammenlignet med andre modeller er Seedream 4.5 sin største fordel kontroll. Den har høyere troverdighet mot referansebilder (multi-bilde-fusjon) og bedre innebygd tekst (typografi), noe som gjør den mer egnet for kommersielt design.',

      faq6Question: 'Kan jeg bruke genererte bilder kommersielt?',
      faq6Answer: 'Ja. Bilder generert med Seedream 4.5 på 微鲤AI kan brukes kommersielt, med forbehold om plattformens vilkår og lokale lover.',

      // CTA Section
      ctaTitle: 'Prøv Seedream 4.5 nå',
      ctaDescription: 'Bruk ByteDance sin kraftigste AI-bildemodell gratis',
      ctaButton: 'Begynn å skape',
      ctaDisclaimer: 'Ingen kredittkort kreves',
      },
    nl: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - ByteDance vlaggenschip AI-beeldmodel',
      pageDescription: 'Seedream 4.5 is ByteDance\'s nieuwste vlaggenschip AI-beeldmodel, gericht op precieze typografie en multi-image fusion met 4K ultra-HD output. Probeer gratis op 微鲤AI.',
      pageKeywords: 'Seedream 4.5, AI-beeldgeneratie, typografierendering, multi-image fusion, ByteDance, 4K-kwaliteit, 微鲤AI',
      ogTitle: 'Seedream 4.5 AI Image Generator | 微鲤AI',
      ogDescription: 'Seedream 4.5, ByteDance\'s vlaggenschip AI-beeldmodel met precieze typografie en multi-image fusion',
      twitterTitle: 'Seedream 4.5 - ByteDance vlaggenschip AI-beeldgeneratie',
      twitterDescription: 'Ervaar krachtige beeldgeneratie met Seedream 4.5, precieze typografie en 4K ultra-HD kwaliteit',

      // Generator Section
      generatorTitle: 'Seedream 4.5 Image Generator',
      generatorSubtitle: 'Seedream 4.5 Image Generator is ByteDance\'s nieuwste vlaggenschip AI-beeldmodel. Als grote upgrade van de Seedream-serie doorbreekt het de beperkingen van traditionele text-to-image modellen en focust het op de moeilijkste problemen rond consistentie en tekstrendering in professionele creatie. Het model staat bekend om indrukwekkende multi-image fusion, precieze typografie en filmische controle over lichtdetails, waardoor het ideaal is voor designers, e-commerce professionals en brand creators. Probeer de ultieme professionele creatiekracht van Seedream 4.5 gratis op 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Seedream 4.5 kernfuncties',
      coreFeaturesSubtitle: 'Ontdek de krachtige functies van Seedream 4.5 en start je professionele AI-beeldcreatiereis',

      feature1Title: 'Precieze typografie en tekstrendering',
      feature1Desc: 'Seedream 4.5 lost het veelvoorkomende probleem van vervormde tekst in AI-beelden op. Het kan duidelijke, correct gespelde titels, labels en lange zinnen genereren, ideaal voor posters, boekomslagen en productbeelden met logo\'s.',
      feature1Alt: 'Seedream 4.5 voorbeeld van precieze typografie',

      feature2Title: 'Multi-image fusion en consistentiecontrole',
      feature2Desc: 'Ondersteunt tot 10 referentiebeelden tegelijk. Het model kan karakterkenmerken, kledingdetails of omgevingsstijlen uit verschillende beelden halen en perfect combineren, zodat karakter-ID en kernelementen zeer consistent blijven over scènes.',
      feature2Alt: 'Seedream 4.5 multi-image fusion voorbeeld',

      feature3Title: 'Intelligent inpainting en bewerking',
      feature3Desc: 'In tegenstelling tot simpele mask-inpainting begrijpt Seedream 4.5 de oorspronkelijke lichtlogica van de scène. Bij "kleding wijzigen" of "achtergrond wijzigen" vervangt het niet alleen het object, maar past het ook automatisch reflecties en schaduwen aan, voor een naadloze wijziging.',
      feature3Alt: 'Seedream 4.5 intelligent inpainting voorbeeld',

      feature4Title: 'Filmische 4K ultra-HD kwaliteit',
      feature4Desc: 'Ondersteunt native 4K-resolutie met hoge detailweergave zonder upschaal nabewerking. De verbeterde physics renderer simuleert real-world camera diepte, materiaaltexturen (zoals huidporiën en stofvezels) en complexe lichtverspreiding.',
      feature4Alt: 'Seedream 4.5 4K-kwaliteit voorbeeld',

      // How to Use
      howToUseTitle: 'Seedream 4.5 gebruiken op 微鲤AI',
      howToUseSubtitle: 'Start in drie eenvoudige stappen',

      step1Title: 'Selecteer model',
      step1Description: 'Kies Seedream 4.5 in de AI Image tools',

      step2Title: 'Voer content in',
      step2Description: 'Voer prompts in of upload referentiebeelden',

      step3Title: 'Genereer beeld',
      step3Description: 'Klik op genereren en download je beeld',

      // YouTube Section
      youtubeTitle: 'YouTube-video\'s over het Seedream 4.5 AI-beeldmodel',

      // X Posts Section
      xPostsTitle: 'X-berichten over het Seedream 4.5 AI-beeldmodel',

      // Explore Models
      exploreModelsTitle: 'Ontdek andere beeldmodellen op 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      // FAQ
      faqTitle: 'Veelgestelde vragen',

      faq1Question: 'Wat is Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 is een geavanceerd AI-beeldgeneratie- en bewerkingsmodel van ByteDance, toonaangevend in visuele consistentie, precieze tekstreproductie en output in hoge resolutie.',

      faq2Question: 'Wat kan het?',
      faq2Answer: 'Het excelleert in posters/logo\'s met correcte tekst, doorlopende storyboards met consistente karakter-ID\'s, realistische e-commerce productbeelden en complexe lokale bewerkingen (zoals kleding of achtergrond wijzigen).',

      faq3Question: 'Is het gratis te gebruiken op 微鲤AI?',
      faq3Answer: '微鲤AI biedt dagelijks gratis credits voor geregistreerde gebruikers om Seedream 4.5 te proberen. Voor bulkproductie of commerciële HD-downloads zonder watermark bieden we flexibele abonnementen.',

      faq4Question: 'Hoe is de beeldkwaliteit?',
      faq4Answer: 'Seedream 4.5 ondersteunt native 4K-output met fijne detailweergave en strikte lichtlogica; het behaalt commerciële fotokwaliteit in huidtextuur en materiaalweergave (zoals metaal en glas).',

      faq5Question: 'Wat is het verschil met Flux.1 of Midjourney?',
      faq5Answer: 'Vergeleken met andere modellen is de grootste kracht van Seedream 4.5 de controleerbaarheid. Het heeft hogere trouw aan referentiebeelden (multi-image fusion) en presteert beter in ingebedde tekst (typografie), waardoor het geschikter is voor commercieel design.',

      faq6Question: 'Kan ik gegenereerde beelden commercieel gebruiken?',
      faq6Answer: 'Ja, beelden gegenereerd via Seedream 4.5 op 微鲤AI mogen commercieel worden gebruikt, onder voorbehoud van platformvoorwaarden en lokale wetgeving.',

      // CTA Section
      ctaTitle: 'Probeer Seedream 4.5 nu',
      ctaDescription: 'Gebruik ByteDance\'s krachtigste AI-beeldmodel gratis',
      ctaButton: 'Begin met creëren',
      ctaDisclaimer: 'Geen creditcard vereist',
      },
    id: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - Model Generasi Gambar AI Flagship ByteDance',
      pageDescription: 'Seedream 4.5 adalah model gambar AI flagship terbaru ByteDance, berfokus pada rendering tipografi presisi dan fusi multi-gambar dengan output 4K ultra-HD. Coba gratis di 微鲤AI.',
      pageKeywords: 'Seedream 4.5, generasi gambar AI, rendering tipografi, fusi multi-gambar, ByteDance, kualitas 4K, 微鲤AI',
      ogTitle: 'Seedream 4.5 AI Image Generator | 微鲤AI',
      ogDescription: 'Seedream 4.5, model gambar AI flagship ByteDance dengan tipografi presisi dan fusi multi-gambar',
      twitterTitle: 'Seedream 4.5 - Generasi Gambar AI Flagship ByteDance',
      twitterDescription: 'Rasakan generasi gambar Seedream 4.5 yang kuat, tipografi presisi, kualitas 4K ultra-HD',

      // Generator Section
      generatorTitle: 'Generator Gambar Seedream 4.5',
      generatorSubtitle: 'Seedream 4.5 Image Generator adalah model gambar AI flagship terbaru ByteDance. Sebagai peningkatan besar seri Seedream, ia menembus batas model text-to-image tradisional dengan fokus pada masalah konsistensi dan rendering teks tersulit dalam kreasi profesional. Model ini terkenal karena fusi multi-gambar yang luar biasa, generasi tipografi yang presisi, dan kontrol sinematik atas detail pencahayaan, sehingga ideal untuk desainer, profesional e‑commerce, dan brand creator. Coba kemampuan kreatif profesional Seedream 4.5 secara gratis di 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Fitur Inti Seedream 4.5',
      coreFeaturesSubtitle: 'Jelajahi fitur kuat Seedream 4.5 dan mulai perjalanan kreasi gambar AI profesional',

      feature1Title: 'Tipografi Presisi & Rendering Teks',
      feature1Desc: 'Seedream 4.5 mengatasi masalah teks berantakan pada gambar AI. Ia dapat menghasilkan judul, label, dan kalimat panjang yang jelas serta ejaan benar di dalam gambar, ideal untuk poster, sampul buku, dan gambar produk berlogo.',
      feature1Alt: 'Contoh tipografi presisi Seedream 4.5',

      feature2Title: 'Fusi Multi-Gambar & Kontrol Konsistensi',
      feature2Desc: 'Mendukung input hingga 10 gambar referensi sekaligus. Model ini dapat mengekstrak fitur karakter, detail pakaian, atau gaya lingkungan dari gambar berbeda dan memadukannya sempurna ke gambar baru, memastikan ID karakter dan elemen inti tetap konsisten di berbagai adegan.',
      feature2Alt: 'Contoh fusi multi-gambar Seedream 4.5',

      feature3Title: 'Inpainting & Editing Cerdas',
      feature3Desc: 'Berbeda dari inpainting masker sederhana, Seedream 4.5 memahami logika pencahayaan asli scene. Saat Anda meminta "ganti pakaian" atau "ganti latar", ia tidak hanya mengganti objek, tetapi juga menyesuaikan cahaya pantulan dan bayangan di sekitarnya sehingga perubahan terlihat mulus.',
      feature3Alt: 'Contoh inpainting cerdas Seedream 4.5',

      feature4Title: 'Kualitas Sinematik 4K Ultra HD',
      feature4Desc: 'Mendukung output 4K native dengan detail tinggi tanpa upscaling pascaproses. Mesin rendering fisik yang ditingkatkan dapat mensimulasikan depth of field kamera dunia nyata, tekstur material (seperti pori kulit, serat kain), dan efek hamburan cahaya kompleks.',
      feature4Alt: 'Contoh kualitas 4K Seedream 4.5',

      // How to Use
      howToUseTitle: 'Cara Menggunakan Seedream 4.5 di 微鲤AI',
      howToUseSubtitle: 'Mulai dalam tiga langkah sederhana',

      step1Title: 'Pilih Model',
      step1Description: 'Pilih Seedream 4.5 di alat AI Image',

      step2Title: 'Masukkan Konten',
      step2Description: 'Masukkan prompt atau unggah gambar referensi',

      step3Title: 'Buat Gambar',
      step3Description: 'Klik generate dan unduh gambar Anda',

      // YouTube Section
      youtubeTitle: 'Video YouTube tentang Model Gambar AI Seedream 4.5',

      // X Posts Section
      xPostsTitle: 'Posting X tentang Model Gambar AI Seedream 4.5',

      // Explore Models
      exploreModelsTitle: 'Jelajahi Model Gambar Lain di 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      // FAQ
      faqTitle: 'Pertanyaan yang Sering Diajukan',

      faq1Question: 'Apa itu Seedream 4.5?',
      faq1Answer: 'Seedream 4.5 adalah model generasi dan editing gambar AI canggih dari ByteDance, memimpin industri dalam konsistensi visual, reproduksi teks presisi, dan output resolusi tinggi.',

      faq2Question: 'Apa yang bisa dilakukan?',
      faq2Answer: 'Unggul untuk poster/logo dengan teks akurat, storyboard berkelanjutan dengan ID karakter konsisten, gambar produk e‑commerce realistis, serta editing gambar lokal yang kompleks (misalnya ganti pakaian atau latar).',

      faq3Question: 'Apakah gratis digunakan di 微鲤AI?',
      faq3Answer: '微鲤AI memberikan kredit gratis harian untuk pengguna terdaftar agar dapat mencoba Seedream 4.5. Untuk produksi massal atau unduhan HD tanpa watermark untuk komersial, kami menawarkan paket berlangganan yang fleksibel.',

      faq4Question: 'Bagaimana kualitas gambar?',
      faq4Answer: 'Seedream 4.5 mendukung output 4K native dengan detail halus dan logika pencahayaan yang ketat, mencapai kualitas fotografi komersial pada tekstur kulit dan representasi material (seperti logam, kaca).',

      faq5Question: 'Apa bedanya dengan Flux.1 atau Midjourney?',
      faq5Answer: 'Dibanding model lain, keunggulan terbesar Seedream 4.5 adalah kontrolabilitas. Ia lebih setia pada gambar referensi (fusi multi-gambar) dan lebih baik dalam menghasilkan teks tertanam (tipografi), sehingga lebih cocok untuk desain komersial.',

      faq6Question: 'Bisakah saya menggunakan gambar yang dihasilkan secara komersial?',
      faq6Answer: 'Ya, gambar yang dihasilkan melalui Seedream 4.5 di 微鲤AI dapat digunakan secara komersial, sesuai ketentuan layanan platform dan hukum setempat.',

      // CTA Section
      ctaTitle: 'Coba Seedream 4.5 Sekarang',
      ctaDescription: 'Gunakan model generasi gambar AI terkuat ByteDance secara gratis',
      ctaButton: 'Mulai Berkarya',
      ctaDisclaimer: 'Tidak perlu kartu kredit',
      },
    tr: {
      // SEO Meta
      pageTitle: 'Seedream 4.5 - ByteDance amiral gemisi AI görsel modeli',
      pageDescription:
        'Seedream 4.5, ByteDance’in en yeni amiral gemisi AI görsel modelidir. Hassas tipografi render’ı ve çoklu görsel füzyonu ile 4K Ultra HD çıktı sunar. 微鲤AI’de ücretsiz deneyin.',
      pageKeywords:
        'Seedream 4.5, AI görsel üretimi, tipografi render, çoklu görsel füzyon, ByteDance, 4K kalite, 微鲤AI',
      ogTitle: 'Seedream 4.5 AI Görsel Oluşturucu | 微鲤AI',
      ogDescription:
        'Seedream 4.5, hassas tipografi ve çoklu görsel füzyon sunan ByteDance amiral gemisi AI görsel modeli',
      twitterTitle: 'Seedream 4.5 - ByteDance amiral gemisi AI görsel üretimi',
      twitterDescription:
        'Seedream 4.5’in güçlü görsel üretimini, hassas tipografiyi ve 4K Ultra HD kaliteyi deneyimleyin',

      // Generator Section
      generatorTitle: 'Seedream 4.5 Görsel Oluşturucu',
      generatorSubtitle:
        'Seedream 4.5 Görsel Oluşturucu, ByteDance’in en yeni amiral gemisi AI görsel modelidir. Seedream serisinin büyük bir yükseltmesi olarak, geleneksel metinden‑görsele modellerinin sınırlarını aşar ve profesyonel üretimdeki en zorlu tutarlılık ve metin render sorunlarını çözmeye odaklanır. Model; güçlü çoklu görsel füzyonu, hassas tipografi üretimi ve sinematik ışık kontrolüyle tasarımcılar, e‑ticaret profesyonelleri ve marka yaratıcıları için ideal bir araçtır. Seedream 4.5’in profesyonel yaratıcı gücünü 微鲤AI’de ücretsiz deneyin!',

      // Core Features
      coreFeaturesTitle: 'Seedream 4.5 Temel Özellikler',
      coreFeaturesSubtitle:
        'Seedream 4.5’in güçlü özelliklerini keşfedin ve profesyonel AI görsel üretimine başlayın',

      feature1Title: 'Hassas tipografi ve metin render’ı',
      feature1Desc:
        'Seedream 4.5, AI görsellerdeki metin bozulması sorununu çözer. Görsellerde net ve doğru yazılmış başlıklar, etiketler ve uzun cümleler üretebilir; posterler, kitap kapakları ve logolu ürün görselleri için idealdir.',
      feature1Alt: 'Seedream 4.5 hassas tipografi örneği',

      feature2Title: 'Çoklu görsel füzyon ve tutarlılık kontrolü',
      feature2Desc:
        'Aynı anda 10 referans görsele kadar giriş destekler. Model, farklı görsellerden karakter özelliklerini, kıyafet detaylarını veya ortam stilini akıllıca çıkarır ve yeni bir görselde kusursuz biçimde birleştirir; karakter ID’si ve çekirdek öğeler sahneler arasında yüksek tutarlılıkta kalır.',
      feature2Alt: 'Seedream 4.5 çoklu görsel füzyon örneği',

      feature3Title: 'Akıllı inpainting ve düzenleme',
      feature3Desc:
        'Basit maske inpainting’inden farklı olarak Seedream 4.5 sahnenin özgün ışık mantığını anlar. “Kıyafet değiştir” veya “arka plan değiştir” gibi isteklerde yalnızca nesneyi değiştirmekle kalmaz, çevredeki yansımaları ve gölgeleri de otomatik ayarlayarak doğal bir sonuç verir.',
      feature3Alt: 'Seedream 4.5 akıllı inpainting örneği',

      feature4Title: 'Sinematik 4K Ultra HD kalite',
      feature4Desc:
        'Sonradan yükseltme olmadan native 4K yüksek detaylı görüntü üretimini destekler. Geliştirilmiş fiziksel render motoru; gerçekçi alan derinliği, malzeme dokuları (cilt gözenekleri, kumaş lifleri) ve karmaşık ışık saçılımı etkilerini simüle eder.',
      feature4Alt: 'Seedream 4.5 4K kalite örneği',

      // How to Use
      howToUseTitle: '微鲤AI’de Seedream 4.5 nasıl kullanılır?',
      howToUseSubtitle: 'Üç adımda başlayın',

      step1Title: 'Model seçin',
      step1Description: 'AI Görsel araçlarında Seedream 4.5’i seçin',

      step2Title: 'İçerik girin',
      step2Description: 'Prompt yazın veya referans görseller yükleyin',

      step3Title: 'Görsel üretin',
      step3Description: 'Üret’e tıklayın ve görselinizi indirin',

      // YouTube Section
      youtubeTitle: 'Seedream 4.5 AI görsel modeliyle ilgili YouTube videoları',

      // X Posts Section
      xPostsTitle: 'Seedream 4.5 AI görsel modeliyle ilgili X gönderileri',

      // Explore Models
      exploreModelsTitle: '微鲤AI’deki diğer görsel modelleri keşfedin',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Qwen Image',
      model3Title: 'Dreamina',

      // FAQ
      faqTitle: 'Sıkça sorulan sorular',

      faq1Question: 'Seedream 4.5 nedir?',
      faq1Answer:
        'Seedream 4.5, ByteDance tarafından geliştirilen gelişmiş bir AI görsel üretim ve düzenleme modelidir; görsel tutarlılık, hassas metin üretimi ve yüksek çözünürlükte sektör lideridir.',

      faq2Question: 'Neler yapabilir?',
      faq2Answer:
        'Doğru metin içeren poster/logo üretimi, tutarlı karakter ID’leriyle sürekli storyboard’lar, gerçekçi e‑ticaret ürün görselleri ve karmaşık yerel düzenlemelerde (ör. kıyafet/arka plan değiştirme) öne çıkar.',

      faq3Question: '微鲤AI’de ücretsiz mi?',
      faq3Answer:
        '微鲤AI, kayıtlı kullanıcılara Seedream 4.5’i denemeleri için günlük ücretsiz krediler sağlar. Toplu üretim veya ticari HD filigransız indirmeler için esnek abonelik planları sunuyoruz.',

      faq4Question: 'Görsel kalitesi nasıl?',
      faq4Answer:
        'Seedream 4.5, hassas görüntü kalitesi ve sıkı ışık mantığıyla native 4K çıktı destekler; özellikle portre cilt dokusu ve malzeme temsili (metal, cam) ticari fotoğraf düzeyindedir.',

      faq5Question: 'Flux.1 veya Midjourney’den farkı nedir?',
      faq5Answer:
        'Diğer modellere kıyasla Seedream 4.5’in en büyük avantajı kontrol edilebilirliktir. Referans görsellere daha yüksek sadakat (çoklu görsel füzyon) ve gömülü metin üretiminde daha iyi performans sunar; bu da ticari tasarımlar için daha uygundur.',

      faq6Question: 'Üretilen görselleri ticari olarak kullanabilir miyim?',
      faq6Answer:
        'Evet. 微鲤AI platformunda Seedream 4.5 ile üretilen görseller, platform hizmet şartları ve yerel yasalara bağlı olarak ticari amaçla kullanılabilir.',

      // CTA Section
      ctaTitle: 'Seedream 4.5’i şimdi deneyin',
      ctaDescription:
        'ByteDance’in en güçlü AI görsel üretim modelini ücretsiz kullanın',
      ctaButton: 'Oluşturmaya başla',
      ctaDisclaimer: 'Kredi kartı gerekmez',
    },
}
